import * as angular from "angular";
import * as _ from "lodash";
import {VehicleType} from "../../commons/types/vehicle.type";
import {IQService} from "angular";
import {DeliveriesService} from "../../deliveries/services/deliveries-service.service";
import {PlanningCommonService} from "../../planning/services/planning-coomon-service.service";
import {AccountModel} from "../../account/angular/models/account.model";
import {TaskModel} from "../../tasks/models/task.model";
import {SplitService} from "../../commons/services/split-service.service";
import {AgentModel} from "../../agents/angular/models/agent.model";
import {AgentType} from "../../agents/types/agent.type";
import {AgentsService} from "../../agents/services/agents-service.service";
import {StopsClusterModel} from "../../planning/models/stops-cluster.model";

export class MapsCommonService {

  markersSpriteConfig = {
    slaColor: {
      Pickup: {
        1: 5,
        2: 6,
        3: 7,
        4: 8
      },
      Dropoff: {
        1: 9,
        2: 10,
        3: 11,
        4: 12,
      },
      Operation: {
        1: 13,
        2: 14,
        3: 15,
        4: 16,
      }
    },
    timeWindowColor: {
      Pickup: {
        0: 0,
        1: 1,
        2: 2,
        3: 3,
        4: 4,
        5: 5,
        6: 6,
        7: 7,
        8: 8,
        9: 9,
        10: 10,
        11: 11,
        12: 12,
        13: 13,
        14: 14,
        15: 15,
        16: 16,
        17: 17,
        18: 18,
        19: 19,
        20: 20,
        21: 21,
        22: 22,
        23: 23,
        24: 24
      },
      Dropoff: {
        0: 25,
        1: 26,
        2: 27,
        3: 28,
        4: 29,
        5: 30,
        6: 31,
        7: 32,
        8: 33,
        9: 34,
        10: 35,
        11: 36,
        12: 37,
        13: 38,
        14: 39,
        15: 40,
        16: 41,
        17: 42,
        18: 43,
        19: 44,
        20: 45,
        21: 46,
        22: 47,
        23: 48,
        24: 49
      },
      Operation: {
        0: 50,
        1: 51,
        2: 52,
        3: 53,
        4: 54,
        5: 55,
        6: 56,
        7: 57,
        8: 58,
        9: 59,
        10: 60,
        11: 61,
        12: 62,
        13: 63,
        14: 64,
        15: 65,
        16: 66,
        17: 67,
        18: 68,
        19: 69,
        20: 70,
        21: 71,
        22: 72,
        23: 73,
        24: 74
      }
    },
    purpose: {
      Pickup: 0,
      Dropoff: 1,
      Operation: 2,
      Start: 3,
      End: 4
    },
    status: {
      Unassigned: 1,
      Assigned: 2,
      CourierHeading: 3,
      CourierApproaching: 3,
      CourierArrived: 4,
      CourierDeparted: 6,
      ManualHandled: 6,
      Canceled: 8,
      ContactNotAvailable: 8
    }
  }
  markerConfig: any;
  markerColorByStatus: any;
  markerColorBySla: any;
  addressColors = {
    regular: '#c5c5c5',
    edit: '#F44336'
  };
  mapZIndexes = {
    agent: {
      default: 10,
      selected: 12
    },
    depot: {
      default: 10,
      selected: 12
    },
    account: {
      default: 10,
      selected: 12
    },
    task: {
      default: 20,
      selected: 25
    },
    routedTask: {
      default: 30,
      highlighted: 1000,
      selected: 32
    },
    job: {
      default: 20,
      selected: 22
    },
    planning: {
      activity: 200,
      unrouted: 20
    }
  };

  private $trashIcon: any;

  constructor(private splitService: SplitService, private $q: IQService, private deliveriesService: DeliveriesService,
              private tasksConstants, private agentsService: AgentsService,
              private planningCommonService: PlanningCommonService, private $filter, private moment, private UUIDService) {
    this.$trashIcon = document.createElement('IMG');
    this.$trashIcon.setAttribute("src", 'assets/images/icons/v2/trash.svg');
    this.$trashIcon.classList.add('bringoz-icon-small');

    this.markerColorByStatus = this.tasksConstants.statusToColor;
    this.markerColorBySla = this.tasksConstants.slaIndexToColor;
    this.markerConfig = {
      Pickup: {
        color: this.tasksConstants.purposeToColor.Pickup,
        icons: {
          routed: 'routed-task-pickup-label',
          unrouted: 'unrouted-task-pickup-label',
        }
      },
      Dropoff: {
        color: this.tasksConstants.purposeToColor.Dropoff,
        icons: {
          routed: 'routed-task-dropoff-label',
          unrouted: 'unrouted-task-dropoff-label',
        }
      },
      Operation: {
        color: this.tasksConstants.purposeToColor.Operation,
        icons: {
          routed: 'routed-task-operation-label',
          unrouted: 'unrouted-task-operation-label',
        }
      },
      Start: {
        color: this.tasksConstants.purposeToColor.Start,
        icons: {
          routed: 'routed-task-operation-label',
          unrouted: 'unrouted-task-operation-label',
        }
      },
      End: {
        color: this.tasksConstants.purposeToColor.End,
        icons: {
          routed: 'routed-task-operation-label',
          unrouted: 'unrouted-task-operation-label',
        }
      },
      Default: {
        color: '#808080'
      }
    };
  }

  getTasksRadiusPayload(agent) {
    return [
      {
        id: 'arriving',
        center: {}, // latitude/longitude
        radius: agent.geofencingArrivalTaskRadius || 0,
        stroke: {
          color: '#50BEB7',
          weight: 2,
          opacity: 1
        },
        fill: {
          color: '#50beb7',
          opacity: 0.3
        },
        geodesic: false, // optional: defaults to false
        draggable: false, // optional: defaults to false
        clickable: false, // optional: defaults to true
        editable: false, // optional: defaults to false
        visible: true, // optional: defaults to true
        control: {}
      },
      {
        id: 'departing',
        center: {}, // latitude/longitude
        radius: agent.geofencingDepartureTaskRadius || 0,
        stroke: {
          color: '#646464',
          weight: 2,
          opacity: 1
        },
        fill: {
          color: '#646464',
          opacity: 0.3
        },
        geodesic: false, // optional: defaults to false
        draggable: false, // optional: defaults to false
        clickable: false, // optional: defaults to true
        editable: false, // optional: defaults to false
        visible: true, // optional: defaults to true
        control: {}
      },
    ];
  }

  getPlanningCluster(stopCluster: StopsClusterModel, click?: Function) {
    const result = {
      id: stopCluster.clusterHashId,
      center: stopCluster.center, // latitude/longitude
      radius: getRadius(stopCluster.center, stopCluster.points),
      stroke: {
        color: '#50BEB7',
        weight: 2,
        opacity: 1
      },
      fill: {
        color: '#50beb7',
        opacity: 0.3
      },
      geodesic: false, // optional: defaults to false
      draggable: false, // optional: defaults to false
      clickable: true, // optional: defaults to true
      editable: false, // optional: defaults to false
      visible: true, // optional: defaults to true
      control: {},
      events: {}
    }

    if (click) {
      result.events = {
        click,
        mouseover: (circle: google.maps.Circle) => {
          circle.setOptions({ strokeWeight: 4, fillOpacity: 0.5 });
        },
        mouseout: (circle: google.maps.Circle) => {
          circle.setOptions({ strokeWeight: 2, fillOpacity: 0.3 });
        }
      }
    }

    return result;

    function getRadius(center, points) {
      const toRad = (deg) => (deg * Math.PI) / 180;

      function haversineDistance(coord1, coord2) {
        const R = 6371e3; // Earth radius in meters
        const lat1 = toRad(coord1[1]);
        const lat2 = toRad(coord2[1]);
        const dLat = toRad(coord2[1] - coord1[1]);
        const dLng = toRad(coord2[0] - coord1[0]);

        const a =
          Math.sin(dLat / 2) * Math.sin(dLat / 2) +
          Math.cos(lat1) * Math.cos(lat2) *
          Math.sin(dLng / 2) * Math.sin(dLng / 2);

        const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

        return R * c; // distance in meters
      }

      let maxDistance = 0;
      for (const point of points) {
        const dist = haversineDistance(center, point);
        if (dist > maxDistance) {
          maxDistance = dist;
        }
      }
      return maxDistance; // radius in meters
    }
  }

  // function convertRoutesToGeoJson(routes) {
  //   var features = [];
  //
  //   _.forEach(routes, function(route) {
  //     var taskFeatures = _getRouteTasksFeatures(route.taskListExt, route, route.agentId),
  //       taskPolylineFeature = _getRouteTasksPolylineFeature(route.taskListExt, route, route.agentId);
  //
  //     features =  features.concat(taskFeatures, [taskPolylineFeature]);
  //   })
  // }

  convertStopsToGeoJson(stops, draggable?) {
    return {
      type: "FeatureCollection",
      metadata: {
        generated: this.moment().valueOf(),
        title: "Bringoz Routed Tasks Feature Collection"
      },
      features: this.getStopsFeatures(stops, draggable)
    }
  }

  convertFulfillmentLinesTasksToGeoJson(fulfillmentLines) {
    return {
      type: "FeatureCollection",
      metadata: {
        generated: this.moment().valueOf(),
        title: "Bringoz Fulfillment Tasks Feature Collection"
      },
      features: this.getFulfillmentLinesTasksFeatures(fulfillmentLines)
    }
  }


  convertTasksToGeoJson(tasks) {
    const taskFeatures = this.getTasksFeatures(tasks);

    return {
      type: "FeatureCollection",
      metadata: {
        generated: this.moment().valueOf(),
        title: "Bringoz Routed Tasks Feature Collection"
      },
      features: taskFeatures
    }
  }

  convertAgentsToGeoJson(agents: AgentModel[]) {
    let agentsFeatures = this.getAgentsFeatures(agents);

    return {
      type: "FeatureCollection",
      metadata: {
        generated: this.moment().valueOf(),
        title: "Bringoz Agents Feature Collection"
      },
      features: agentsFeatures
    }
  }

  convertAccountsToGeoJson(accounts: AccountModel[]) {
    let features = this.getAccountsFeatures(accounts);

    return {
      type: "FeatureCollection",
      metadata: {
        generated: this.moment().valueOf(),
        title: "Bringoz Accounts Feature Collection"
      },
      features: features
    }
  }

  agentIrregularityGeoJson(irregularities, agentId) {
    const outOfServiceAreaIrregularitiesFeatures = this.getAgentOutOfServiceAreaIrregularityFeatures(irregularities.outOfServiceArea, agentId);
    const taskCompletionLocationIrregularitiesFeatures = this.getTaskCompletionLocationIrregularityFeatures(irregularities.completionDistanceFromTaskLocation, agentId);

    return {
      type: "FeatureCollection",
      metadata: {
        generated: this.moment().valueOf(),
        title: "Irregularities"
      },
      features: [...outOfServiceAreaIrregularitiesFeatures, ...taskCompletionLocationIrregularitiesFeatures]
    }
  }

  private getAgentOutOfServiceAreaIrregularityFeatures(irregularities, agentId) {

    if (!irregularities?.length) {
      return [];
    }
    return _.map(irregularities, (item, index) => {
      return {
        type: "Feature",
        properties: {
          id: `outOfServiceArea-${item.fromDate}`,
          type: 'outOfServiceAreaIrregularity',
          ref: item,
          agentId: agentId
        },
        geometry: {
          type: "Point",
          coordinates: [item.fromLocation.lng, item.fromLocation.lat]
        }
      }
    })
  }

  private getTaskCompletionLocationIrregularityFeatures(irregularities, agentId) {

    if (!irregularities?.length) {
      return [];
    }

    return _.map(irregularities, (item, index) => {
      return {
        type: "Feature",
        properties: {
          id: `completionLocationIrregularity-${item.taskId}`,
          ref: item,
          type: 'taskCompletionLocationIrregularity',
          agentId: agentId
        },
        geometry: {
          type: "Point",
          coordinates: [item.actualLocation.lng, item.actualLocation.lat]
        }
      }
    })
  }

  convertDepotsToGeoJson(depots: any[]) {
    let features = this.getDepotsFeatures(depots);

    return {
      type: "FeatureCollection",
      metadata: {
        generated: this.moment().valueOf(),
        title: "Bringoz Depots Feature Collection"
      },
      features: features
    }
  }

  convertRoutedTasksToGeoJson(tasks?, route?, agentId?, excludeTasksPolyline?, ignoreDaySequence?) {
    let features;
    let taskFeatures = this.getRouteTasksFeatures(tasks, route, agentId, ignoreDaySequence);
    if (!excludeTasksPolyline) {
      let taskPolylineFeature: any = this.getRouteTasksPolylineFeature(tasks, route, agentId);
      features = _.concat(taskFeatures, [taskPolylineFeature]);
    } else {
      features = taskFeatures;
    }

    return {
      type: "FeatureCollection",
      metadata: {
        generated: this.moment().valueOf(),
        title: "Bringoz Routed Tasks Feature Collection"
      },
      features: features
    }
  }

  convertItineraryTasksToGeoJson(tasks, agentId, isUseDaySequenceAsTaskIndex) {
    let taskFeatures = this.getItineraryTasksFeatures(tasks, agentId, isUseDaySequenceAsTaskIndex)
    let taskPolylineFeature: any = this.getItineraryTasksPolylineFeature(tasks, agentId)
    let features = _.concat(taskFeatures, [taskPolylineFeature]);

    return {
      type: "FeatureCollection",
      metadata: {
        generated: this.moment().valueOf(),
        title: "Bringoz Routed Tasks Feature Collection"
      },
      features: features
    }
  }

  convertItinerariesToGeoJson(itineraries, tasks, isUseDaySequenceAsTaskIndex) {

    let features = [];

    _.forEach(itineraries, (itinerary) => {

      let taskListExt = itinerary.taskListExt;

      if (!taskListExt && !!_.get(tasks, 'length')) {
        taskListExt = _.map(itinerary.taskIdListExt, (id) => {
          return _.find(tasks, (t) => {
            return t.id === id;
          })
        })
      }

      const taskFeatures = this.getItineraryTasksFeatures(taskListExt, itinerary.agent.id, true),
        taskPolylineFeature = this.getRouteTasksPolylineFeature(taskListExt, undefined, itinerary.agent.id);

      features = features.concat(taskFeatures, [taskPolylineFeature]);
    })

    return {
      type: "FeatureCollection",
      metadata: {
        generated: this.moment().valueOf(),
        title: "Bringoz Multi Itineraries Tasks Feature Collection"
      },
      features: features
    }
  }

  convertRoutesPolylineToGeoJson(routes, routeColor?) {

    if (!routes?.length) {
      return;
    }

    let routesPolylineFeatures = [];

    routes.forEach((r) => {
      const routePolyline = this.getRoutePolylineFeature(r, routeColor);
      if (!!routePolyline) {
        routesPolylineFeatures.push(routePolyline);
      }
    })

    return {
      type: "FeatureCollection",
      metadata: {
        generated: this.moment().valueOf(),
        title: "Routes Polyline Feature Collection"
      },
      features: routesPolylineFeatures
    }
  }

  convertRoutedActivitiesToGeoJson(route, routeColor?, draggable?) {
    let taskFeatures = this.getRouteActivitiesFeatures(route, draggable, routeColor);
    let taskPolylineFeature: any = this.getRouteActivitiesPolylineFeature(route, routeColor);
    let features = _.concat(taskFeatures || [], [taskPolylineFeature]);

    return {
      type: "FeatureCollection",
      metadata: {
        generated: this.moment().valueOf(),
        title: "Bringoz Routed Tasks Feature Collection"
      },
      features: features
    }
  }

  convertLogisticsVehiclesToGeoJson(logisticsVehicles) {
    let logisticsVehiclesFeatures = this.getLogisticsVehiclesFeatures(logisticsVehicles)

    return {
      type: "FeatureCollection",
      metadata: {
        generated: this.moment().valueOf(),
        title: "Bringoz Logistics Vehicles Feature Collection"
      },
      features: logisticsVehiclesFeatures
    }
  }

  private getStopsFeatures(stops, draggable?) {

    const locationStops = _.filter(stops, (s) => {
      return _.get(s, 'address.location.lat') && _.get(s, 'address.location.lng');
    });

    return _.map(locationStops, function (s, index) {
      return {
        type: "Feature",
        id: s.id,
        properties: {
          id: s.id,
          stopId: s.id,
          jobId: s.jobId,
          ref: s,
          routeId: s.routeId,
          purpose: s.stopType,
          pricePlanProgramType: s.pricePlanProgramType,
          coordinates: {lat: s.address.location.lat, lng: s.address.location.lng}
        },
        geometry: {
          type: "Point",
          coordinates: [s.address.location.lng, s.address.location.lat]
        },
        draggable: draggable
      }
    })
  }

  private getFulfillmentLinesTasksFeatures(fulfillmentLines) {

    let fulfillmentLinesTasks = []
    _.forEach(fulfillmentLines, item => {
      if (item.pickupTask && item.pickupTask.location?.address?.location) {
        fulfillmentLinesTasks.push(item.pickupTask);
      }
      if (item.destinationTask && item.destinationTask.location?.address?.location) {
        fulfillmentLinesTasks.push(item.destinationTask);
      }
    });

    return _.map(fulfillmentLinesTasks, function (task, index) {
      return {
        type: "Feature",
        id: task.id,
        properties: {
          id: task.id,
          ref: task,
          purpose: task.purpose,
          coordinates: {lat: task.location.address.location.lat, lng: task.location.address.location.lng}
        },
        geometry: {
          type: "Point",
          coordinates: [task.location.address.location.lng, task.location.address.location.lat]
        }
      }
    })
  }

  private getTasksFeatures(tasks) {

    const locationTasks = _.filter(tasks, (t) => {
      return _.get(t, 'taskSpec.address.location.lat') && _.get(t, 'taskSpec.address.location.lng');
    });

    return _.map(locationTasks, function (t, index) {
      return {
        type: "Feature",
        id: t.id,
        properties: {
          id: t.id,
          type: t.taskType,
          agentId: t.agentId,
          serviceId: t.serviceId,
          purpose: t.taskSpec.purpose,
          status: t.status,
          taskSpec: t.taskSpec,
          title: t.taskSpec.address.place,
          place: t.taskSpec.address.place,
          address: t.taskSpec.address
        },
        geometry: {
          type: "Point",
          coordinates: [t.taskSpec.address.location.lng, t.taskSpec.address.location.lat]
        }
      }
    })
  }


  private getAgentsFeatures(agents) {
    return _.map(agents, (a, index) => {
      return {
        type: "Feature",
        id: a.id,
        properties: {
          id: a.id,
          ref: a
        },
        geometry: {
          type: "Point",
          coordinates: !!a.lastKnownLocation?.coordinates ? [a.lastKnownLocation?.coordinates.longitude, a.lastKnownLocation?.coordinates.latitude] : []
        }
      }
    })
  }

  private getAccountsFeatures(accounts) {

    const locationEntities = accounts.filter((a) => {
      return !!a.address?.location;
    })

    return _.map(locationEntities, (a, index) => {
      return {
        type: "Feature",
        id: a.id,
        properties: {
          id: a.id,
          ref: a
        },
        geometry: {
          type: "Point",
          coordinates: [a.address.location.longitude || _.get(a.address, ' location.lng'), a.address.location.latitude || _.get(a.address, ' location.lat')]
        }
      }
    })
  }

  private getDepotsFeatures(depots) {

    const locationEntities = depots.filter((d) => {
      return !!d.address?.location;
    })

    return _.map(locationEntities, (d, index) => {
      return {
        type: "Feature",
        id: d.id,
        properties: {
          id: d.id,
          displayColor: d.displayColor,
          ref: d
        },
        geometry: {
          type: "Point",
          coordinates: [d.address.location.lng, d.address.location.lat]
        }
      }
    })
  }

  private getRouteTasksFeatures(tasks, route, agentId, ignoreDaySequence = false) {

    const locationTasks = _.filter(tasks, (t) => {
      return _.get(t, 'taskSpec.address.location.lat') && _.get(t, 'taskSpec.address.location.lng');
    });
    const taskIndexOffset: number = locationTasks[0]?.taskType === 'Internal' ? 0 : 1;

    return _.map(locationTasks, (t, index) => {
      let taskIndex = _.get(t, 'routeAnalysis.daySequence');
      if (_.isUndefined(taskIndex) || ignoreDaySequence) {
        taskIndex = index + taskIndexOffset;
      }

      return {
        type: "Feature",
        id: t.id,
        properties: {
          id: t.id,
          type: t.taskType,
          agentId: agentId,
          serviceId: t.serviceId,
          serviceIds: t.bundleServiceIdList,
          routeId: _.get(route, 'id'),
          color: _.get(route, 'color'),
          indexInRoute: taskIndex,
          purpose: t.taskSpec.purpose,
          status: t.status,
          title: t.taskSpec.address.place,
          place: t.taskSpec.address.place,
          address: t.taskSpec.address,
          hideMapMarker: !!t.hideMapMarker,
          zIndex: taskIndex
        },
        geometry: {
          type: "Point",
          coordinates: [t.taskSpec.address.location.lng, t.taskSpec.address.location.lat]
        },
        draggable: true
      }
    })
  }

  private getItineraryTasksFeatures(tasks, agentId, isUseDaySequenceAsTaskIndex) {

    const locationTasks = _.filter(tasks, (t) => {
      return _.get(t, 'taskSpec.address.location.lat') && _.get(t, 'taskSpec.address.location.lng');
    });

    return _.map(locationTasks, (t, index) => {
      const taskIndex = isUseDaySequenceAsTaskIndex ? _.get(t, 'analysis.daySequence') : index + 1;
      return {
        type: "Feature",
        id: t.id,
        properties: {
          id: t.id,
          type: t.taskType,
          agentId: agentId,
          serviceId: t.serviceId,
          index: taskIndex || '-',
          purpose: t.taskSpec.purpose,
          status: t.status,
          title: t.taskSpec.address.place,
          place: t.taskSpec.address.place,
          address: t.taskSpec.address
        },
        geometry: {
          type: "Point",
          coordinates: [t.taskSpec.address.location.lng, t.taskSpec.address.location.lat]
        }
      }
    })
  }

  private getLogisticsVehiclesFeatures(logisticsVehicles) {

    const logisticsVehiclesWithLocation = _.filter(logisticsVehicles, (l) => {
      return _.get(l, 'coordinates.latitude') && _.get(l, 'coordinates.longitude');
    })

    return _.map(logisticsVehiclesWithLocation, (l, index) => {
      return {
        type: "Feature",
        id: l.id,
        properties: {
          ref: l,
          id: l.id,
          vehicleType: _.get(l, 'vehicleTypeReference.type'),
          name: l.name,
          coordinates: {
            lat: l.coordinates.latitude,
            lng: l.coordinates.longitude,
            latitude: l.coordinates.latitude,
            longitude: l.coordinates.longitude
          }
        },
        geometry: {
          type: "Point",
          coordinates: [l.coordinates.longitude, l.coordinates.latitude]
        }
      }
    })
  }

  private getRouteActivitiesFeatures(route, draggable, routeColor) {

    if (!route.activities?.length) {
      return;
    }

    const color = routeColor || this.planningCommonService.getRouteColor(route);
    const agentId = _.get(route, 'resource.agentId');
    const holderId = _.get(route, 'resource.resourceHolderId');

    const activities = _.filter(route.activities, (a) => {
      return _.get(a, 'address.location.lat') &&
        _.get(a, 'address.location.lng') &&
        !_.isEqual(a.type, 'START') &&
        !_.isEqual(a.type, 'END');
    })

    return _.map(activities, (a, index) => {
      return {
        type: "Feature",
        id: a.id,
        properties: {
          ref: a,
          id: a.id,
          jobId: a.jobId,
          jobIds: a.jobIds,
          type: a.type,
          routeId: a.routeId,
          agentId: agentId,
          holderId: holderId,
          agentName: route.resource?.agentName,
          color: color,
          indexInRoute: index + 1,
          tripNumber: a.tripNumber,
          title: a.address.place,
          place: a.address.place,
          stopId: a.stopId,
          stopIds: a.stopIds,
          coordinates: {lat: a.address.location.lat, lng: a.address.location.lng}
        },
        geometry: {
          type: "Point",
          coordinates: [a.address.location.lng, a.address.location.lat]
        },
        draggable: draggable
      }
    })
  }

  private getRouteTasksPolylineFeature(tasks, route, agentId) {

    const locationTasks = _.filter(tasks, (t) => {
      return _.get(t, 'taskSpec.address.location.lat') && _.get(t, 'taskSpec.address.location.lng');
    });

    return {
      type: "Feature",
      properties: {
        type: 'POLYLINE',
        agentId: agentId,
        routeId: _.get(route, 'id'),
        color: _.get(route, 'color'),
      },
      geometry: {
        type: "LineString",
        coordinates: _.map(locationTasks, (t) => {
          return [t.taskSpec.address.location.lng, t.taskSpec.address.location.lat]
        })
      }
    }
  }

  private getItineraryTasksPolylineFeature(tasks, agentId) {

    var locationTasks = _.filter(tasks, function (t) {
      return _.get(t, 'taskSpec.address.location.lat') && _.get(t, 'taskSpec.address.location.lng');
    });

    return {
      type: "Feature",
      properties: {
        type: 'POLYLINE',
        agentId: agentId
      },
      geometry: {
        type: "LineString",
        coordinates: _.map(locationTasks, function (t) {
          return [t.taskSpec.address.location.lng, t.taskSpec.address.location.lat]
        })
      }
    }
  }

  private getRoutePolylineFeature(route, routeColor?) {
    let coordinates;


    const color = routeColor || this.planningCommonService.getRouteColor(route);

    if (route.routePolyline || route.polyline) {
      coordinates = this.decodePolylineCoordinates(route.routePolyline || route.polyline);

      return {
        type: "Feature",
        properties: {
          id: route.id,
          type: 'POLYLINE',
          routeId: route.id,
          color: color
        },
        geometry: {
          type: "LineString",
          coordinates: coordinates
        }
      }
    }

    return;
  }

  private getRouteActivitiesPolylineFeature(route, routeColor?) {

    let coordinates;
    const color = routeColor || this.planningCommonService.getRouteColor(route);

    if (route.routePolyline || route.polyline) {
      coordinates = this.decodePolylineCoordinates(route.routePolyline || route.polyline);
    } else {
      const activities = _.filter(route.activities, (a) => {
        return _.get(a, 'address.location.lat') && _.get(a, 'address.location.lng');
      })
      coordinates = _.map(activities, (a) => {
        return [a.address.location.lng, a.address.location.lat]
      })
    }

    return {
      type: "Feature",
      properties: {
        id: route.id,
        type: 'POLYLINE',
        routeId: route.id,
        agentId: _.get(route, 'resource.agentId'),
        holderId: _.get(route, 'resource.resourceHolderId'),
        color: color
      },
      geometry: {
        type: "LineString",
        coordinates: coordinates
      }
    }
  }

  getTaskFeatureStyle(feature?, visible?, isSelected?) {

    const featureType = feature.getProperty('type'),
      color = feature.getProperty('color'),
      purpose = feature.getProperty('purpose'),
      status = feature.getProperty('status'),
      indexInRoute = feature.getProperty('indexInRoute') || feature.getProperty('index'),
      isPolyline = _.isEqual(featureType, 'POLYLINE'),
      isTask = _.isEqual(featureType, 'Stopover') || _.isEqual(featureType, 'Internal'),
      isGroup = _.isEqual(featureType, 'BundledStopover');

    const style = {
      // visible: _.includes(ctrl.hiddenRouteIds, routeId) ? false : ctrl.filters.routes,
      visible: _.isUndefined(visible) ? true : visible,
      zIndex: isSelected ? google.maps.Marker.MAX_ZINDEX : undefined,
      fillColor: color
    }

    if (isPolyline) {
      _.set(style, 'strokeColor', color);
      _.set(style, 'strokeWeight', 2);
      _.set(style, 'icons', [{
        icon: {
          path: google.maps.SymbolPath.FORWARD_OPEN_ARROW
        },
        stroke: {
          color: color || '#000000',
          weight: 1.5,
          opacity: 1
        },
        offset: '50px',
        repeat: '150px'
      }])
    } else {
      if (color) {
        _.set(style, 'icon', this.buildRoutedTaskIcon(isSelected, false, color, isGroup, indexInRoute));
      } else {
        _.set(style, 'icon', this.buildRoutedTaskIconWithStatus(purpose, status, indexInRoute, isSelected, isGroup));
      }
    }

    return style;
  }

  getRouteTaskFeatureStyle(feature?, visible?, isSelected?) {

    const featureType = feature.getProperty('type'),
      color = feature.getProperty('color'),
      purpose = feature.getProperty('purpose'),
      status = feature.getProperty('status'),
      indexInRoute = feature.getProperty('indexInRoute') || feature.getProperty('index'),
      isPolyline = _.isEqual(featureType, 'POLYLINE'),
      isTask = _.isEqual(featureType, 'Stopover') || _.isEqual(featureType, 'Internal'),
      isInternal = _.isEqual(featureType, 'Internal'),
      isGroup = _.isEqual(featureType, 'BundledStopover');

    const style = {
      // visible: _.includes(ctrl.hiddenRouteIds, routeId) ? false : ctrl.filters.routes,
      visible: _.isUndefined(visible) ? true : visible,
      zIndex: isSelected ? google.maps.Marker.MAX_ZINDEX : feature.getProperty('zIndex'),
      fillColor: color
    }

    if (isPolyline) {
      _.set(style, 'strokeColor', color);
      _.set(style, 'strokeWeight', 2);
      _.set(style, 'icons', [{
        icon: {
          path: google.maps.SymbolPath.FORWARD_OPEN_ARROW
        },
        stroke: {
          color: color || '#000000',
          weight: 1.5,
          opacity: 1
        },
        offset: '50px',
        repeat: '150px'
      }])
    } else {
      _.set(style, 'icon', isInternal ?
        this.buildStartEndPointIcon(indexInRoute === 0) :
        this.buildRouteIcon(isSelected, false, color, isGroup, indexInRoute));
    }

    return style;
  }

  getAgentPerformanceTaskFeatureStyle(feature?, visible?, taskColor?, isSelected?, isHighlighted?) {

    const featureType = feature.getProperty('type'),
      color = feature.getProperty('color') || taskColor,
      purpose = feature.getProperty('purpose'),
      status = feature.getProperty('status'),
      // != null check: indexInRoute can legitimately be 0 (timekeeping Start stop)
      indexInRoute = feature.getProperty('indexInRoute') != null ? feature.getProperty('indexInRoute') : feature.getProperty('index'),
      isGroup = _.isEqual(featureType, 'BundledStopover');

    if (feature.getProperty('hideMapMarker')) {
      return { visible: false };
    }

    const style = {
      visible: _.isUndefined(visible) ? true : visible,
      zIndex: isSelected ? google.maps.Marker.MAX_ZINDEX : undefined,
      fillColor: color
    }

    if (color) {
      _.set(style, 'icon', this.buildRouteIcon(isSelected, isHighlighted, color, isGroup, indexInRoute));
    } else {
      _.set(style, 'icon', this.buildRoutedTaskIconWithStatus(purpose, status, indexInRoute, isSelected, isGroup));
    }

    return style;
  }

  getAgentTaskFeatureStyle(feature?, visible?, isSelected?) {

    const featureType = feature.getProperty('type'),
      color = feature.getProperty('color'),
      purpose = feature.getProperty('purpose'),
      status = feature.getProperty('status'),
      indexInRoute = feature.getProperty('indexInRoute') || feature.getProperty('index'),
      isPolyline = _.isEqual(featureType, 'POLYLINE'),
      isTask = _.isEqual(featureType, 'Stopover') || _.isEqual(featureType, 'Internal'),
      isGroup = _.isEqual(featureType, 'BundledStopover');

    const style = {
      // visible: _.includes(ctrl.hiddenRouteIds, routeId) ? false : ctrl.filters.routes,
      visible: _.isUndefined(visible) ? true : visible,
      zIndex: isSelected ? google.maps.Marker.MAX_ZINDEX : undefined,
      fillColor: color
    }

    if (isPolyline) {
      _.set(style, 'strokeColor', color);
      _.set(style, 'strokeWeight', 2);
      _.set(style, 'icons', [{
        icon: {
          path: google.maps.SymbolPath.FORWARD_OPEN_ARROW
        },
        stroke: {
          color: color || '#000000',
          weight: 1.5,
          opacity: 1
        },
        offset: '50px',
        repeat: '150px'
      }])
    } else {
      if (color) {
        _.set(style, 'icon', this.buildRoutedTaskIcon(isSelected, false, color, isGroup, indexInRoute));
      } else {
        _.set(style, 'icon', this.buildRoutedTaskIconWithStatus(purpose, status, indexInRoute, isSelected, isGroup));
      }
    }

    return style;
  }

  getAgentIrregularityFeatureStyle() {
    const style = {
      visible: true
    }

    _.set(style, 'icon', {
      url: 'assets/images/icons/map/irregularity.svg',
      size: new google.maps.Size(28, 28),
      anchor: new google.maps.Point(14, 14)
    })

    return style;
  }

  getLogisticsVehicleStyle(feature, isSelected?) {
    const vehicleType = feature.getProperty('vehicleType');

    const style = {
      visible: true,
      zIndex: isSelected ? google.maps.Marker.MAX_ZINDEX : 1
    }

    _.set(style, 'icon', {
      url: vehicleType === VehicleType.Trailer ? 'assets/images/icons/map/trailer-marker.svg' : 'assets/images/icons/map/logistics-vehicle-marker.svg',
      size: new google.maps.Size(38, 38),
      anchor: new google.maps.Point(19, 19)
    })

    return style;
  }

  getRoutePolylineFeatureStyle(feature, customStyleOptions?, visible?) {
    const color = feature.getProperty('color');
    const style: any = {
      visible: _.isUndefined(visible) ? true : visible,
      fillColor: color,
      zIndex: 1,
      icons: []
    };

    _.set(style, 'strokeColor', color);
    _.set(style, 'strokeWeight', !_.isUndefined(customStyleOptions?.strokeWeight) ? customStyleOptions?.strokeWeight : 2);
    _.set(style, 'strokeOpacity', !_.isUndefined(customStyleOptions?.strokeOpacity) ? customStyleOptions?.strokeOpacity : 1);

    if (!!customStyleOptions?.dottedLine) {
      const dottedLine = {
        icon: {
          path: "M 0,-1 0,1",
          strokeOpacity: 1,
          scale: 3,
        },
        repeat: "30px",
      };
      style.icons.push(dottedLine);
    }

    const squareIcon = {
      icon: {
        path: "M -2,-2 2,-2 2,2 -2,2 Z",
        fillColor: color || '#000000',
        fillOpacity: 2,
        strokeColor: color || '#000000',
        strokeWeight: 2,
        scale: 1,
      },
      repeat: '20px'
    };

    const arrowsIcon = {
      icon: {
        path: google.maps.SymbolPath.FORWARD_OPEN_ARROW,
        fillColor: color || '#000000',
        fillOpacity: 1,
        strokeColor: color || '#000000',
        strokeWeight: 2,
        scale: 1,
      },
      repeat: '15px'
    };

    if (customStyleOptions?.displaySquare) {
      style.icons.push(squareIcon);
    }

    if (customStyleOptions?.displayArrow) {
      style.icons.push(arrowsIcon);
    }

    return style;
  }

  getActivityFeatureStyle(feature, visible?, isSelected?, isDisplayRetrips?, activityCustomText?, isDimmed?) {
    const featureType = feature.getProperty('type'),
      routeId = feature.getProperty('routeId'),
      indexInRoute = feature.getProperty('indexInRoute'),
      tripNumber = isDisplayRetrips ? feature.getProperty('tripNumber') : undefined,
      isPolyline = _.isEqual(featureType, 'POLYLINE'),
      isStop = _.isEqual(featureType, 'STOP'),
      isGroup = _.isEqual(featureType, 'GROUP');

    let color = feature.getProperty('color');

    if (isDimmed) {
      color = this.lightenHexColor(color, 0.4);
    }

    const style = {
      visible: _.isUndefined(visible) ? true : visible,
      fillColor: color,
      zIndex: isSelected ? google.maps.Marker.MAX_ZINDEX : indexInRoute
    }

    if (isPolyline) {
      _.set(style, 'strokeColor', color);
      _.set(style, 'strokeWeight', 2);
      _.set(style, 'icons', [{
        icon: {
          path: google.maps.SymbolPath.FORWARD_OPEN_ARROW
        },
        stroke: {
          color: color || '#000000',
          weight: 1.5,
          opacity: 1
        },
        offset: '50px',
        repeat: '150px'
      }])
    } else {
      _.set(style, 'icon', (isStop || isGroup) ?
        this.buildRouteIcon(isSelected, false, color, isGroup, indexInRoute, tripNumber, activityCustomText) :
        this.buildStartEndPointIcon(indexInRoute === 0))
    }

    return style;
  }

  getDepotMarkers(depots) {

    const filteredDepots = _.filter(depots, (d) => {
      return !!_.get(d, 'address.location.lat') && !!_.get(d, 'address.location.lng');
    })

    return _.map(filteredDepots, (d, i) => {
      return {
        id: d.id,
        address: d.address,
        name: d.name,
        coords: {
          latitude: d.address.location.lat,
          longitude: d.address.location.lng
        },
        icon: this.buildDepotTaskIcon(false),
        zIndex: this.mapZIndexes.depot.default + i,
        show: true
      };
    });
  }

  getAccountMarkers(accounts: AccountModel[]) {
    const filteredAccounts = _.filter(accounts, (a) => {
      return !!_.get(a, 'address.location.lat') && !!_.get(a, 'address.location.lng');
    });

    return filteredAccounts.map((a, i) => ({
        id: a.id,
        name: a.accountReference?.name || '',
        address: a.address,
        coords: {
          latitude: a.address?.location.latitude || _.get(a.address, ' location.lat'),
          longitude: a.address?.location.longitude || _.get(a.address, 'location.lng')
        },
        icon: this.getAccountIcon(),
        zIndex: this.mapZIndexes.account.default + i,
        show: true
    }));
  }

  private getMarkerLabelClass(purpose, isRouted, isUnpacked) {
    const iconsRef = this.markerConfig[purpose].icons;
    let classString = isRouted ? iconsRef.routed : iconsRef.unrouted;

    if (isUnpacked) {
      classString += ' fa fa-cube'
    }
    return classString
  }

  setAgentIcons(agents, selectedId, isVisible) {
    _.forEach(agents, (agent) => {
      if (!agent.options) {
        agent.options = {};
      }
      agent.options.visible = isVisible;
      if (selectedId === agent.id) {
        agent.options.icon = this.getSelectedAgentIcon(agent);
        agent.options.zIndex = this.mapZIndexes.agent.selected;
      } else {
        agent.options.icon = this.getAgentIcon(agent);
        agent.options.zIndex = this.mapZIndexes.agent.default;
      }
    })
  }

  getRoutedTaskMarkersWithStatus(tasks?, isVisible?, useIndex?) {

    const tasksCopy = _.map(tasks, (t, i) => {

      if (!_.get(t, 'taskSpec.address.location.lat') || !_.get(t, 'taskSpec.address.location.lng')) {
        return false;
      }

      const isBundle = _.isEqual(t.taskType, 'BundledStopover');
      const daySequence = _.get(t, 'routeAnalysis.daySequence');
      let index = useIndex ? (i + 1) : daySequence;
      if (!index || index <= 0) {
        index = '';
      }

      return {
        id: t.id,
        ref: t,
        taskId: t.id,
        serviceId: t.serviceId,
        serviceIds: t.bundleServiceIdList,
        bundleInfo: isBundle ? t.numberOfTasks : undefined,
        taskType: t.taskType,
        markerIndex: i,
        taskSpec: t.taskSpec,
        coords: t.taskSpec.address.location,
        icon: this.buildRoutedTaskIconWithStatus(t.taskSpec.purpose, t.status, index, false, isBundle),
        visible: !_.isUndefined(t.visible) ? t.visible : isVisible,
        options: {
          visible: !_.isUndefined(t.visible) ? t.visible : isVisible,
        },
        agentId: t.agentId,
        zIndex: this.mapZIndexes.planning.activity + i
      };
    });

    return _.filter(tasksCopy, (t) => {
      return !!t
    });
  }

  getRouteTaskMarkers(tasks?, isVisible?, selectedId?, color?) {

    tasks = _.filter(tasks, (t) => {
      return _.get(t, 'taskSpec.address.location.lat', false) && _.get(t, 'taskSpec.address.location.lng', false);
    })

    return _.map(tasks, (t, i) => {
      const isSelected = _.isEqual(t.id, selectedId),
        isBundle = _.isEqual(t.taskType, 'BundledStopover'),
        isComplete = _.isEqual(t.status, 'CourierDeparted'),
        indexInRoute = i + 1;

      const taskPurpose = t.taskSpec.purpose;
      const taskColor = color || _.get(this.markerConfig[taskPurpose], 'color', 'black');

      // return {
      //   id: a.id,
      //   routeId: a.routeId,
      //   coords: {
      //     latitude: a.address.location.lat,
      //     longitude: a.address.location.lng,
      //   },
      //   // icon: buildTaskIconPlaceholderWithStatus(a.stopType, false),
      // }

      return {
        id: t.id,
        taskId: t.id,
        serviceId: t.serviceId,
        bundleInfo: isBundle ? t.numberOfTasks : undefined,
        taskType: t.taskType,
        taskSpec: t.taskSpec,
        markerIndex: i,
        type: t.taskType,
        ref: t,
        routeId: t.routeId,
        routeColor: color || 'black',
        coords: {
          latitude: t.taskSpec.address.location.lat,
          longitude: t.taskSpec.address.location.lng
        },
        icon: this.buildRoutedTaskIcon(isSelected, false, taskColor, isBundle, indexInRoute),
        zIndex: this.mapZIndexes.planning.activity + i,
        isComplete: isComplete,
        show: true,
        enabled: true
      };
    });
  }

  getRouteActivityMarkers(activities?, isVisible?, selectedId?, color?) {

    activities = _.filter(activities, (a) => {
      return _.get(a, 'address.location.lat', false) && _.get(a, 'address.location.lng', false);
    })

    return _.map(activities, (a, i) => {
      let isStop = _.isEqual(a.type, 'STOP'),
        isGroup = _.isEqual(a.type, 'GROUP'),
        isSelected = _.isEqual(a.id, selectedId);

      // return {
      //   id: a.id,
      //   routeId: a.routeId,
      //   coords: {
      //     latitude: a.address.location.lat,
      //     longitude: a.address.location.lng,
      //   },
      //   // icon: buildTaskIconPlaceholderWithStatus(a.stopType, false),
      // }

      return {
        id: a.id,
        activityId: a.id,
        markerIndex: i,
        stopId: a.stopId,
        stopType: a.stopType,
        type: a.type,
        ref: a,
        routeId: a.routeId,
        indexInRoute: a.indexInRoute,
        routeColor: color,
        coords: {
          latitude: a.address.location.lat,
          longitude: a.address.location.lng
        },
        options: {
          visible: !_.isUndefined(isVisible) ? isVisible : true,
        },
        visible: !_.isUndefined(isVisible) ? isVisible : true,
        icon: this.getAgentIcon(),
        // icon: (isStop || isGroup) ? buildActivityIcon(isSelected, false, color, isGroup, indexInRoute)
        //     : buildStartEndPointIcon(i === 0),
        // options: {
        //   zIndex: mapZIndexes.planning.activity + activityIndex,
        //   visible: _.isUndefined(isVisible) ? true : isVisible,
        //   label: {
        //     text: isStop ? (activityIndex - 1).toString() : a.type.charAt(0),
        //     color: 'white',
        //     fontSize: '11px'
        //   },
        //   // labelContent: isStop ? activityIndex - 1 : a.type.charAt(0),
        //   // labelAnchor: isStop ? (activityIndex >= 100 ? '10' : activityIndex >= 10 ? '8' : '3') + ' 24' : '-7 50',
        //   // labelClass: isStop ? 'routed-activity-label' : 'start-end-points-label'
        // },
        zIndex: this.mapZIndexes.planning.activity + (a.indexInRoute || i),
        enabled: true
      };
    });
  }

  getUnRouteStopMarkers(stops, selectedJobIds, isVisible) {

    if (!selectedJobIds) {
      selectedJobIds = [];
    }

    stops = _.filter(stops, (s) => {
      return !!_.get(s, 'address.location.lat') && !!_.get(s, 'address.location.lng')
    })

    return _.map(stops, (s, i) => {
      const isSelected = _.indexOf(selectedJobIds, s.jobId) !== -1;

      return {
        id: s.id,
        stopId: s.id,
        jobId: s.jobId,
        ref: s,
        routeId: s.routeId,
        purpose: s.stopType,
        coords: {
          latitude: s.address.location.lat,
          longitude: s.address.location.lng
        },
        icon: this.buildUnRoutedActivityIcon(s.stopType, isSelected),
        options: {
          zIndex: this.mapZIndexes.planning.unrouted + i,
          visible: _.isUndefined(isVisible) ? true : isVisible,
          // labelContent: s.stopType.charAt(0),
          // labelAnchor: '5 25',
          // labelClass: '' // 'unrouted-task-pickup-label' : 'unrouted-task-dropoff-label'
        },
        isSelected: isSelected
      };
    });
  }

  centerMapByBounds(map, markers) {

    if (markers && markers.length) {
      const bounds = new google.maps.LatLngBounds();

      markers.forEach(function (marker) {
        let latLng;

        if (marker.coords) {
          latLng = new google.maps.LatLng(marker.coords.latitude,
            marker.coords.longitude);
        } else if (_.get(marker, 'location.location')) {
          latLng = new google.maps.LatLng(marker.location.location.latitude,
            marker.location.location.longitude);
        } else if (_.get(marker, 'location.address.location')) {
          latLng = new google.maps.LatLng(marker.location.address.location.latitude,
            marker.location.address.location.longitude);
        } else if (_.get(marker, 'lastKnownLocation.coordinates')) {
          latLng = new google.maps.LatLng(marker.lastKnownLocation.coordinates.latitude,
            marker.lastKnownLocation.coordinates.longitude);
        }

        if (latLng) {
          bounds.extend(latLng);
        }
      });

      map.bounds = {
        northeast: {
          latitude: bounds.getNorthEast().lat(),
          longitude: bounds.getNorthEast().lng()
        },
        southwest: {
          latitude: bounds.getSouthWest().lat(),
          longitude: bounds.getSouthWest().lng()
        }
      };
    } else {
      const siteLocation = this.getSiteLocation();
      map.center.latitude = siteLocation.lat;
      map.center.longitude = siteLocation.lng;
      map.zoom = 12;
    }
  }


  getSiteLocation() {
    const address = this.splitService.getSiteAddress();
    return _.get(address, 'location', this.getDefaultCenter())
  }

  getDefaultStyle() {
    return [
      {
        "elementType": "labels.text.fill",
        "stylers": [
          {
            "color": "#7c93a3"
          },
          {
            "lightness": -10
          }
        ]
      },
      {
        "featureType": "administrative.country",
        "elementType": "geometry",
        "stylers": [
          {
            "visibility": "on"
          }
        ]
      },
      {
        "featureType": "administrative.country",
        "elementType": "geometry.stroke",
        "stylers": [
          {
            "color": "#a0a4a5"
          }
        ]
      },
      {
        "featureType": "administrative.locality",
        "elementType": "labels.text.fill",
        "stylers": [
          {
            "color": "#000000"
          }
        ]
      },
      {
        "featureType": "administrative.locality",
        "elementType": "labels.text.stroke",
        "stylers": [
          {
            "color": "#ffffff"
          }
        ]
      },
      {
        "featureType": "administrative.neighborhood",
        "stylers": [
          {
            "visibility": "on"
          }
        ]
      },
      {
        "featureType": "administrative.neighborhood",
        "elementType": "labels.text.fill",
        "stylers": [
          {
            "color": "#2b2b27"
          }
        ]
      },
      {
        "featureType": "administrative.neighborhood",
        "elementType": "labels.text.stroke",
        "stylers": [
          {
            "color": "#ffffff"
          }
        ]
      },
      {
        "featureType": "administrative.province",
        "elementType": "geometry.stroke",
        "stylers": [
          {
            "color": "#62838e"
          }
        ]
      },
      {
        "featureType": "landscape",
        "elementType": "geometry.fill",
        "stylers": [
          {
            "color": "#dde3e3"
          }
        ]
      },
      {
        "featureType": "landscape.man_made",
        "elementType": "geometry.stroke",
        "stylers": [
          {
            "color": "#3f4a51"
          },
          {
            "weight": "0.30"
          }
        ]
      },
      {
        "featureType": "poi",
        "stylers": [
          {
            "visibility": "simplified"
          }
        ]
      },
      {
        "featureType": "poi.attraction",
        "stylers": [
          {
            "visibility": "off"
          }
        ]
      },
      {
        "featureType": "poi.business",
        "stylers": [
          {
            "visibility": "off"
          }
        ]
      },
      {
        "featureType": "poi.government",
        "stylers": [
          {
            "visibility": "off"
          }
        ]
      },
      {
        "featureType": "poi.medical",
        "stylers": [
          {
            "visibility": "off"
          }
        ]
      },
      {
        "featureType": "poi.park",
        "stylers": [
          {
            "visibility": "off"
          }
        ]
      },
      {
        "featureType": "poi.place_of_worship",
        "stylers": [
          {
            "visibility": "off"
          }
        ]
      },
      {
        "featureType": "poi.school",
        "stylers": [
          {
            "visibility": "off"
          }
        ]
      },
      {
        "featureType": "poi.sports_complex",
        "stylers": [
          {
            "visibility": "off"
          }
        ]
      },
      {
        "featureType": "road",
        "stylers": [
          {
            "visibility": "on"
          }
        ]
      },
      {
        "featureType": "road",
        "elementType": "geometry.stroke",
        "stylers": [
          {
            "visibility": "on"
          }
        ]
      },
      {
        "featureType": "road",
        "elementType": "labels.icon",
        "stylers": [
          {
            "saturation": -100
          }
        ]
      },
      {
        "featureType": "road.arterial",
        "elementType": "labels.icon",
        "stylers": [
          {
            "saturation": -5
          },
          {
            "lightness": 5
          },
          {
            "gamma": 1.78
          }
        ]
      },
      {
        "featureType": "road.highway",
        "elementType": "geometry.fill",
        "stylers": [
          {
            "color": "#bbcacf"
          }
        ]
      },
      {
        "featureType": "road.highway",
        "elementType": "geometry.stroke",
        "stylers": [
          {
            "color": "#bbcacf"
          },
          {
            "weight": 0.5
          }
        ]
      },
      {
        "featureType": "road.highway",
        "elementType": "labels",
        "stylers": [
          {
            "visibility": "on"
          }
        ]
      },
      {
        "featureType": "road.highway",
        "elementType": "labels.text",
        "stylers": [
          {
            "visibility": "on"
          }
        ]
      },
      {
        "featureType": "road.highway.controlled_access",
        "elementType": "geometry.fill",
        "stylers": [
          {
            "color": "#ffffff"
          }
        ]
      },
      {
        "featureType": "road.highway.controlled_access",
        "elementType": "geometry.stroke",
        "stylers": [
          {
            "color": "#a9b4b8"
          }
        ]
      },
      {
        "featureType": "road.arterial",
        "elementType": "labels.text.stroke",
        "stylers": [
          {
            "color": "#ffffff"
          }
        ]
      },
      {
        "featureType": "road.local",
        "elementType": "labels.text.stroke",
        "stylers": [
          {
            "color": "#ffffff"
          }
        ]
      },
      {
        "featureType": "transit",
        "stylers": [
          {
            "visibility": "off"
          }
        ]
      },
      {
        "featureType": "water",
        "elementType": "geometry.fill",
        "stylers": [
          {
            "color": "#a3c7df"
          }
        ]
      }
    ];
  }

  getTasksBounds(tasks) {

    var bounds = new google.maps.LatLngBounds();

    _.forEach(tasks, function (task: TaskModel) {
      if (task.taskSpec && task.taskSpec.address
        && task.taskSpec.address.location) {
        var latLng = new google.maps.LatLng(
          task.taskSpec.address.location.lat,
          task.taskSpec.address.location.lng);
        bounds.extend(latLng);
      }
    });

    return {
      northeast: {
        latitude: bounds.getNorthEast().lat(),
        longitude: bounds.getNorthEast().lng()
      },
      southwest: {
        latitude: bounds.getSouthWest().lat(),
        longitude: bounds.getSouthWest().lng()
      }
    };

  }

  getMarkerBounds(markers) {

    const bounds = new google.maps.LatLngBounds();

    _.forEach(markers, (m) => {
      if (m.location || m.coords) {
        const lat = _.get(m, 'location.lat') || _.get(m, 'coords.latitude'),
          lng = _.get(m, 'location.lng') || _.get(m, 'coords.longitude');

        const latLng = new google.maps.LatLng(lat, lng);
        bounds.extend(latLng);
      }
    });

    return {
      northeast: {
        latitude: bounds.getNorthEast().lat(),
        longitude: bounds.getNorthEast().lng()
      },
      southwest: {
        latitude: bounds.getSouthWest().lat(),
        longitude: bounds.getSouthWest().lng()
      }
    };

  }

  getCoordinatesBounds(coordinates) {
    const bounds = new google.maps.LatLngBounds();

    _.forEach(coordinates, (coords) => {
      if (coords) {
        if (!_.isArray(coords)) {
          coords = [coords.longitude, coords.latitude]
        }
        const latLng = new google.maps.LatLng(coords[1], coords[0]);
        bounds.extend(latLng);
      }
    });

    return {
      northeast: {
        latitude: bounds.getNorthEast().lat(),
        longitude: bounds.getNorthEast().lng()
      },
      southwest: {
        latitude: bounds.getSouthWest().lat(),
        longitude: bounds.getSouthWest().lng()
      }
    };
  }

  getPolygonBounds(coordinates) {
    let bounds = new google.maps.LatLngBounds();
    let i, j;
    let polygonCoords = [];

    for (j = 0; j < coordinates.length; j++) {
      polygonCoords.push(new google.maps.LatLng(coordinates[j].latitude, coordinates[j].longitude));
    }

    for (i = 0; i < polygonCoords.length; i++) {
      bounds.extend(polygonCoords[i]);
    }
    return bounds;
  }

  buildAgentMarker(agent, isVisible: boolean, showAgentsWithoutGpsPermissions?: boolean, coords?: {
    latitude: number,
    longitude: number
  }) {
    if (!agent) {
      return;
    }
    return {
      id: agent.id,
      coords: coords || _.get(agent, 'lastKnownLocation.coordinates') || _.get(agent, 'location.location', {}),
      options: {
        ref: agent,
        icon: this.getAgentIcon(agent),
        visible: !showAgentsWithoutGpsPermissions ?
          (isVisible && this.agentsService.doesAgentHasGpsPermissions(agent)) :
          isVisible,
        draggable: false
      }
    }
  }

  buildMyLocationMarker(coords?, id?, status?, isSelected?, iconColor?) {

    if (!coords) {
      return;
    }

    return {
      id: id || 'myLocation',
      coords: {
        latitude: _.get(coords, 'latitude'),
        longitude: _.get(coords, 'longitude')
      },
      options: {
        icon: id ? this.getTaskMarkerIcon(undefined, status, isSelected, iconColor) : this.getMyLocationIcon(),
        visible: true,
        draggable: false,
        zIndex: isSelected ? this.mapZIndexes.task.selected : this.mapZIndexes.task.default
      }
    }
  }

  buildLocationMarker(id, coords, status, isSelected, iconColor) {

    if (!coords) {
      return;
    }

    return {
      id: id,
      coords: {
        latitude: _.get(coords, 'latitude'),
        longitude: _.get(coords, 'longitude')
      },
      options: {
        icon: id ? this.getTaskMarkerIcon(undefined, status, isSelected, iconColor) : this.getMyLocationIcon(),
        visible: true,
        draggable: false,
        zIndex: isSelected ? this.mapZIndexes.task.selected : this.mapZIndexes.task.default
      }
    }
  }

  getAgentIcon(agent?) {
    const isOnBreak = _.get(agent, 'status') === 'OnDutyOnBreak';
    let url;

    if (agent?.agentType === AgentType.Driver) {
      url = (isOnBreak ? 'assets/images/icons/map/agent-marker-onbreak.svg' : 'assets/images/icons/map/agent-marker.svg');
    } else if (agent?.agentType === AgentType.ServiceAgent) {
      url = (isOnBreak ? 'assets/images/icons/map/serviceagent_onbreak.svg' : 'assets/images/icons/map/serviceagent.svg');
    } else if (agent?.agentType === AgentType.Robot) {
      url = (isOnBreak ? 'assets/images/icons/map/robot_onbreak.svg' : 'assets/images/icons/map/robot.svg');
    } else {
      url = (isOnBreak ? 'assets/images/icons/map/agent-marker-onbreak.svg' : 'assets/images/icons/map/agent-marker.svg');
    }

    return {
      url: url,
      size: new google.maps.Size(38, 38),
      anchor: new google.maps.Point(19, 19)
    };
  }

  createAgentCustomIcon(agent, color, size) {
    const canvas = document.createElement('canvas');
    const context = canvas.getContext('2d');
    canvas.width = size;
    canvas.height = size;

    // Draw circle
    context.beginPath();
    context.arc(size / 2, size / 2, size / 2, 0, 2 * Math.PI);
    context.fillStyle = color || '#125bba'
    context.fill();

    // Draw initials
    context.fillStyle = '#FFFFFF'; // Text color
    context.font = `${size / 2}px Arial`;
    context.textAlign = 'center';
    context.textBaseline = 'middle';
    const initials = agent.user.firstName.charAt(0).toUpperCase() + agent.user.lastName.charAt(0).toUpperCase();
    context.fillText(initials, size / 2, size / 2);

    return canvas.toDataURL();
  }

  getThreeplServiceAgentIcon() {
    return {
      url: 'assets/images/icons/map/serviceagent.svg',
      size: new google.maps.Size(38, 38),
      anchor: new google.maps.Point(19, 19)
    };
  }

  getSelectedAgentIcon(agent?) {
    const isServiceAgent = agent && agent.agentType === 'ServiceAgent';
    return {
      url: isServiceAgent ? 'assets/images/icons/map/serviceagent_selected.svg'
        : 'assets/images/icons/map/agent_selected.svg',
      size: new google.maps.Size(38, 38),
      anchor: new google.maps.Point(19, 19)
    };
  }

  getMyLocationIcon() {
    return {
      url: 'assets/images/icons/v2/gps.svg',
      size: new google.maps.Size(38, 38),
      anchor: new google.maps.Point(19, 19)
    };
  }

  getDefaultCenter() {
    return {
      lat: 32.0688373,
      latitude: 32.0688373,
      lng: 34.79111050000006,
      longitude: 34.79111050000006,
      color: '#F7F7F7'
    }
  }

  buildRoutedTaskIconWithStatus(purpose, status, index, isSelected, isGroup) {
    let taskColor = _.get(this.markerConfig[purpose], 'color', this.markerConfig.Default.color);
    let statusColor = this.markerColorByStatus[status] || this.markerColorByStatus.Default;
    let strokeColor = isGroup ? '#000000' : '#F7F7F7';
    let strokeWidth = isGroup ? 2.3 : 1.5;
    let x = index >= 10 ? 13 : 16;
    let y = index >= 10 ? 22 : 22;
    let markerImageSvg =
      '<svg width="38" height="47" viewBox="0 0 38 47" fill="none" xmlns="http://www.w3.org/2000/svg">'
      + '<g filter="url(#filter0_d)">'
      + '<path d="M20 6C12.8271 6 7.00013 12.2094 7.00013 19.8258C6.95424 30.9751 19.5106 40.2279 20 40.595C20 40.595 33.0458 30.9751 32.9999 19.841C32.9999 12.2094 27.1729 6 20 6Z" fill="' + taskColor + '"/>'
      + '<path d="M20 6C12.8271 6 7.00013 12.2094 7.00013 19.8258C6.95424 30.9751 19.5106 40.2279 20 40.595C20 40.595 33.0458 30.9751 32.9999 19.841C32.9999 12.2094 27.1729 6 20 6Z" stroke="' + strokeColor + '" stroke-width="' + strokeWidth + '"/>'
      + '</g>'
      + '<g filter="url(#filter1_d)">'
      + '<path d="M19.9985 28.7264C25.3705 28.7264 29.7254 24.3715 29.7254 18.9994C29.7254 13.6274 25.3705 9.27246 19.9985 9.27246C14.6264 9.27246 10.2715 13.6274 10.2715 18.9994C10.2715 24.3715 14.6264 28.7264 19.9985 28.7264Z" fill="#F7F7F7"/>'
      + '</g>'
      + '<g filter="url(#filter2_d)">'
      + '<circle cx="10" cy="9" r="6" fill="' + statusColor + '"/>'
      + '<circle cx="10" cy="9" r="6" stroke="#F7F7F7" stroke-width="1.5"/>'
      + '</g>'
      + '<defs>'
      + '<filter id="filter0_d" x="4.25" y="4.25" width="33.5" height="42.2796" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">'
      + '<feFlood flood-opacity="0" result="BackgroundImageFix"/>'
      + '<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/>'
      + '<feOffset dx="1" dy="2"/>'
      + '<feGaussianBlur stdDeviation="1.5"/>'
      + '<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"/>'
      + '<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow"/>'
      + '<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape"/>'
      + '</filter>'
      + '<filter id="filter1_d" x="8.27148" y="8.27246" width="25.4539" height="25.4539" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">'
      + '<feFlood flood-opacity="0" result="BackgroundImageFix"/>'
      + '<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/>'
      + '<feOffset dx="1" dy="2"/>'
      + '<feGaussianBlur stdDeviation="1.5"/>'
      + '<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"/>'
      + '<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow"/>'
      + '<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape"/>'
      + '</filter>'
      + '<filter id="filter2_d" x="0.25" y="0.25" width="19.5" height="19.5" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">'
      + '<feFlood flood-opacity="0" result="BackgroundImageFix"/>'
      + '<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/>'
      + '<feOffset dy="1"/>'
      + '<feGaussianBlur stdDeviation="1.5"/>'
      + '<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"/>'
      + '<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow"/>'
      + '<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape"/>'
      + '</filter>'
      + '</defs>'
      + '<text x="' + x + '" y="' + y + '" font-weight="bold" font-family="Calibri" font-size="12px" fill="black">' + index + '</text>'
      + '</svg>'
    return {
      url: 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(markerImageSvg),
      size: new google.maps.Size(38, 47),
      anchor: new google.maps.Point(20, 41),
      labelOrigin: new google.maps.Point(20, 20)
    }
  }

  buildStepTaskIcon(purpose, index) {
    let taskColor = _.get(this.markerConfig[purpose], 'color', this.markerConfig.Default.color);
    let x = 17;
    let y = 22;
    let taskIndex = index + 1;
    let markerImageSvg =
      '<svg width="38" height="47" viewBox="0 0 38 47" fill="none" xmlns="http://www.w3.org/2000/svg">'
      + '<g filter="url(#filter0_d)">'
      + '<path d="M20 6C12.8271 6 7.00013 12.2094 7.00013 19.8258C6.95424 30.9751 19.5106 40.2279 20 40.595C20 40.595 33.0458 30.9751 32.9999 19.841C32.9999 12.2094 27.1729 6 20 6Z" fill="' + taskColor + '"/>'
      + '<path d="M20 6C12.8271 6 7.00013 12.2094 7.00013 19.8258C6.95424 30.9751 19.5106 40.2279 20 40.595C20 40.595 33.0458 30.9751 32.9999 19.841C32.9999 12.2094 27.1729 6 20 6Z"/>'
      + '</g>'
      + '<g filter="url(#filter1_d)">'
      + '<path d="M19.9985 28.7264C25.3705 28.7264 29.7254 24.3715 29.7254 18.9994C29.7254 13.6274 25.3705 9.27246 19.9985 9.27246C14.6264 9.27246 10.2715 13.6274 10.2715 18.9994C10.2715 24.3715 14.6264 28.7264 19.9985 28.7264Z" fill="#F7F7F7"/>'
      + '</g>'
      + '<defs>'
      + '<filter id="filter0_d" x="4.25" y="4.25" width="33.5" height="42.2796" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">'
      + '<feFlood flood-opacity="0" result="BackgroundImageFix"/>'
      + '<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/>'
      + '<feOffset dx="1" dy="2"/>'
      + '<feGaussianBlur stdDeviation="1.5"/>'
      + '<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"/>'
      + '<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow"/>'
      + '<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape"/>'
      + '</filter>'
      + '<filter id="filter1_d" x="8.27148" y="8.27246" width="25.4539" height="25.4539" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">'
      + '<feFlood flood-opacity="0" result="BackgroundImageFix"/>'
      + '<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/>'
      + '<feOffset dx="1" dy="2"/>'
      + '<feGaussianBlur stdDeviation="1.5"/>'
      + '<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"/>'
      + '<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow"/>'
      + '<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape"/>'
      + '</filter>'
      + '<filter id="filter2_d" x="0.25" y="0.25" width="19.5" height="19.5" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">'
      + '<feFlood flood-opacity="0" result="BackgroundImageFix"/>'
      + '<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/>'
      + '<feOffset dy="1"/>'
      + '<feGaussianBlur stdDeviation="1.5"/>'
      + '<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"/>'
      + '<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow"/>'
      + '<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape"/>'
      + '</filter>'
      + '</defs>'
      + '<text x="' + x + '" y="' + y + '" font-weight="bold" font-family="Calibri" font-size="12px" fill="black">' + taskIndex + '</text>'
      + '</svg>'
    return {
      url: 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(markerImageSvg),
      size: new google.maps.Size(38, 47),
      anchor: new google.maps.Point(20, 41),
      labelOrigin: new google.maps.Point(20, 20)
    }
  }

  buildActivityIcon(isSelected, isHighlighted, fillColor, isGroup, index) {
    let strokeColor = isGroup ? '#000000' : (isSelected ? '#FFEB3B' : '#F7F7F7');
    let strokeWidth = isGroup ? 2.3 : 1.5;
    let x = index >= 10 ? 11 : 14;
    let y = index >= 10 ? 22 : 22;
    let width = isSelected ? 40 : 30;
    let height = isSelected ? 50 : 40;
    let markerImageSvg = `<svg width="${width}" height="${height}" viewBox="0 0 35 45" fill="none" xmlns="http://www.w3.org/2000/svg">\n`
      + '<g filter="url(#filter0_d)">\n'
      + '<path d="M17 4C9.82713 4 4.00013 10.2094 4.00013 17.8258C3.95424 28.9751 16.5106 38.2279 17 38.595C17 38.595 30.0458 28.9751 29.9999 17.841C29.9999 10.2094 24.1729 4 17 4Z" fill="' + fillColor + '"/>\n'
      + '<path d="M17 4C9.82713 4 4.00013 10.2094 4.00013 17.8258C3.95424 28.9751 16.5106 38.2279 17 38.595C17 38.595 30.0458 28.9751 29.9999 17.841C29.9999 10.2094 24.1729 4 17 4Z" stroke="' + strokeColor + '" stroke-width="' + strokeWidth + '"/>\n'
      + '</g>\n'
      + '<g filter="url(#filter1_d)">\n'
      + '<path d="M16.9985 26.7264C22.3705 26.7264 26.7254 22.3715 26.7254 16.9994C26.7254 11.6274 22.3705 7.27246 16.9985 7.27246C11.6264 7.27246 7.27148 11.6274 7.27148 16.9994C7.27148 22.3715 11.6264 26.7264 16.9985 26.7264Z" fill="#F7F7F7"/>\n'
      + '</g>\n'
      + '<defs>\n'
      + '<filter id="filter0_d" x="1.25" y="2.25" width="33.5" height="42.2796" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">\n'
      + '<feFlood flood-opacity="0" result="BackgroundImageFix"/>\n'
      + '<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/>\n'
      + '<feOffset dx="1" dy="2"/>\n'
      + '<feGaussianBlur stdDeviation="1.5"/>\n'
      + '<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"/>\n'
      + '<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow"/>\n'
      + '<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape"/>\n'
      + '</filter>\n'
      + '<filter id="filter1_d" x="5.27148" y="6.27246" width="25.4539" height="25.4539" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">\n'
      + '<feFlood flood-opacity="0" result="BackgroundImageFix"/>\n'
      + '<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/>\n'
      + '<feOffset dx="1" dy="2"/>\n'
      + '<feGaussianBlur stdDeviation="1.5"/>\n'
      + '<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"/>\n'
      + '<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow"/>\n'
      + '<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape"/>\n'
      + '</filter>\n'
      + '</defs>\n'
      + '<text x="' + x + '" y="' + y + '" font-weight="bold" font-family="Calibri" font-size="12px" fill="black">' + index + '</text>'
      + '</svg>';
    return {
      url: 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(markerImageSvg),
      size: new google.maps.Size(width, height),
      anchor: new google.maps.Point(width / 2, height),
      labelOrigin: new google.maps.Point(20, 20)
    }
  }

  buildRouteIcon(isSelected, isHighlighted, fillColor, isGroup, index, tripNumber?, customText?) {
    let strokeColor = isGroup ? '#000000' : (isSelected ? '#FFEB3B' : '#F7F7F7');
    let strokeWidth = isGroup ? 2.3 : 1.5;
    let x = index >= 10 ? 6 : 8;
    let y = 13;
    let width = isHighlighted ? 33.5 : 30;
    let height = isHighlighted ? 33.5 : 30;

    if (!tripNumber) {
      tripNumber = '';
    }

    if (!customText) {
      customText = '';
    }

    let markerImageSvg =
      `<svg width="${width}" height="${height}" viewBox="0 0 21 22" xmlns="http://www.w3.org/2000/svg">`
      + `<path fill-rule="evenodd" clip-rule="evenodd" d="M3 1C1.89543 1 1 1.89543 1 3V15.5764C1 16.681 1.89543 17.5764 3 17.5764H7.48722C7.81525 17.5764 8.12241 17.7373 8.30922 18.0069L9.65007 19.9423C10.0478 20.5163 10.8964 20.5163 11.2941 19.9423L12.6349 18.0069C12.8217 17.7373 13.1289 17.5764 13.4569 17.5764H17.9445C19.049 17.5764 19.9445 16.681 19.9445 15.5764V3C19.9445 1.89543 19.049 1 17.9445 1H3Z" fill="white"/>`
      + `<path d="M12.6349 18.0069L11.8129 17.4374L12.6349 18.0069ZM9.65007 19.9423L10.4721 19.3728L10.4721 19.3728L9.65007 19.9423ZM11.2941 19.9423L12.1161 20.5118L11.2941 19.9423ZM8.30922 18.0069L7.48722 18.5764L8.30922 18.0069ZM2 3C2 2.44772 2.44771 2 3 2V0C1.34315 0 0 1.34314 0 3H2ZM2 15.5764V3H0V15.5764H2ZM3 16.5764C2.44772 16.5764 2 16.1287 2 15.5764H0C0 17.2333 1.34315 18.5764 3 18.5764V16.5764ZM7.48722 16.5764H3V18.5764H7.48722V16.5764ZM10.4721 19.3728L9.13121 17.4374L7.48722 18.5764L8.82807 20.5118L10.4721 19.3728ZM11.8129 17.4374L10.4721 19.3728L12.1161 20.5118L13.4569 18.5764L11.8129 17.4374ZM17.9445 16.5764H13.4569V18.5764H17.9445V16.5764ZM18.9445 15.5764C18.9445 16.1287 18.4968 16.5764 17.9445 16.5764V18.5764C19.6013 18.5764 20.9445 17.2333 20.9445 15.5764H18.9445ZM18.9445 3V15.5764H20.9445V3H18.9445ZM17.9445 2C18.4968 2 18.9445 2.44772 18.9445 3H20.9445C20.9445 1.34314 19.6013 0 17.9445 0V2ZM3 2H17.9445V0H3V2ZM13.4569 18.5764L13.4569 18.5764V16.5764C12.8009 16.5764 12.1865 16.8982 11.8129 17.4374L13.4569 18.5764ZM8.82807 20.5118C9.62344 21.6598 11.3207 21.6598 12.1161 20.5118L10.4721 19.3728L10.4721 19.3728L8.82807 20.5118ZM7.48722 18.5764L7.48722 18.5764L9.13121 17.4374C8.7576 16.8982 8.14327 16.5764 7.48722 16.5764V18.5764Z" fill="#FF88C1"/>`
      + `<path fill-rule="evenodd" clip-rule="evenodd" d="M3 1C1.89543 1 1 1.89543 1 3V15.5764C1 16.681 1.89543 17.5764 3 17.5764H7.48722C7.81525 17.5764 8.12241 17.7373 8.30922 18.0069L9.65007 19.9423C10.0478 20.5163 10.8964 20.5163 11.2941 19.9423L12.6349 18.0069C12.8217 17.7373 13.1289 17.5764 13.4569 17.5764H17.9445C19.049 17.5764 19.9445 16.681 19.9445 15.5764V3C19.9445 1.89543 19.049 1 17.9445 1H3Z" fill="${isSelected ? fillColor : (fillColor + 20)}"/>`
      + `<path d="M12.6349 18.0069L11.8129 17.4374L12.6349 18.0069ZM9.65007 19.9423L10.4721 19.3728L10.4721 19.3728L9.65007 19.9423ZM11.2941 19.9423L12.1161 20.5118L11.2941 19.9423ZM8.30922 18.0069L7.48722 18.5764L8.30922 18.0069ZM2 3C2 2.44772 2.44771 2 3 2V0C1.34315 0 0 1.34314 0 3H2ZM2 15.5764V3H0V15.5764H2ZM3 16.5764C2.44772 16.5764 2 16.1287 2 15.5764H0C0 17.2333 1.34315 18.5764 3 18.5764V16.5764ZM7.48722 16.5764H3V18.5764H7.48722V16.5764ZM10.4721 19.3728L9.13121 17.4374L7.48722 18.5764L8.82807 20.5118L10.4721 19.3728ZM11.8129 17.4374L10.4721 19.3728L12.1161 20.5118L13.4569 18.5764L11.8129 17.4374ZM17.9445 16.5764H13.4569V18.5764H17.9445V16.5764ZM18.9445 15.5764C18.9445 16.1287 18.4968 16.5764 17.9445 16.5764V18.5764C19.6013 18.5764 20.9445 17.2333 20.9445 15.5764H18.9445ZM18.9445 3V15.5764H20.9445V3H18.9445ZM17.9445 2C18.4968 2 18.9445 2.44772 18.9445 3H20.9445C20.9445 1.34314 19.6013 0 17.9445 0V2ZM3 2H17.9445V0H3V2ZM13.4569 18.5764L13.4569 18.5764V16.5764C12.8009 16.5764 12.1865 16.8982 11.8129 17.4374L13.4569 18.5764ZM8.82807 20.5118C9.62344 21.6598 11.3207 21.6598 12.1161 20.5118L10.4721 19.3728L10.4721 19.3728L8.82807 20.5118ZM7.48722 18.5764L7.48722 18.5764L9.13121 17.4374C8.7576 16.8982 8.14327 16.5764 7.48722 16.5764V18.5764Z" fill="${fillColor}"/>`
      + `<text x="${x}" y="${y}" font-weight="bold" font-family="Calibri" font-size="10px" fill="${isSelected ? 'white' : fillColor}">${index}</text>`
      + `<text x="13" y="14" font-weight="bold" font-family="Calibri" font-size="6px" fill="${isSelected ? 'white' : fillColor}">${customText}</text>`
      + `<text x="3" y="15" font-weight="bold" font-family="Calibri" font-size="6px" fill="${isSelected ? 'white' : fillColor}">${tripNumber}</text>`
      + `</svg>`


    // let markerImageSvg =
    //   `<svg width="${width}" height="${height}" viewBox="0 0 35 45" xmlns="http://www.w3.org/2000/svg">`
    // + `<g filter="url(#filter0_d_1461_34296)">`
    // + `<path fill-rule="evenodd" clip-rule="evenodd" d="M3 1C1.89543 1 1 1.89543 1 3V15.5764C1 16.681 1.89543 17.5764 3 17.5764H7.48722C7.81525 17.5764 8.12241 17.7373 8.30922 18.0069L9.65007 19.9423C10.0478 20.5163 10.8964 20.5163 11.2941 19.9423L12.6349 18.0069C12.8217 17.7373 13.1289 17.5764 13.4569 17.5764H17.9445C19.049 17.5764 19.9445 16.681 19.9445 15.5764V3C19.9445 1.89543 19.049 1 17.9445 1H3Z" fill="white"/>`
    // +  `<path fill-rule="evenodd" clip-rule="evenodd" d="M8 2C6.89543 2 6 2.89543 6 4V16.5764C6 17.681 6.89543 18.5764 8 18.5764H12.4872C12.8152 18.5764 13.1224 18.7373 13.3092 19.0069L14.6501 20.9423C15.0478 21.5163 15.8964 21.5163 16.2941 20.9423L17.6349 19.0069C17.8217 18.7373 18.1289 18.5764 18.4569 18.5764H22.9445C24.049 18.5764 24.9445 17.681 24.9445 16.5764V4C24.9445 2.89543 24.049 2 22.9445 2H8Z" fill="${isSelected ? fillColor : (fillColor + 20)}"/>`
    // + `<path d="M18.1867 19.0069L17.3647 18.4374L18.1867 19.0069ZM15.2018 20.9423L16.0238 20.3728L16.0238 20.3728L15.2018 20.9423ZM16.8458 20.9423L17.6678 21.5118L16.8458 20.9423ZM13.861 19.0069L13.039 19.5764L13.861 19.0069ZM7.55176 4C7.55176 3.44772 7.99947 3 8.55176 3V1C6.8949 1 5.55176 2.34314 5.55176 4H7.55176ZM7.55176 16.5764V4H5.55176V16.5764H7.55176ZM8.55176 17.5764C7.99947 17.5764 7.55176 17.1287 7.55176 16.5764H5.55176C5.55176 18.2333 6.89491 19.5764 8.55176 19.5764V17.5764ZM13.039 17.5764H8.55176V19.5764H13.039V17.5764ZM16.0238 20.3728L14.683 18.4374L13.039 19.5764L14.3798 21.5118L16.0238 20.3728ZM17.3647 18.4374L16.0238 20.3728L17.6678 21.5118L19.0087 19.5764L17.3647 18.4374ZM23.4962 17.5764H19.0087V19.5764H23.4962V17.5764ZM24.4962 16.5764C24.4962 17.1287 24.0485 17.5764 23.4962 17.5764V19.5764C25.1531 19.5764 26.4962 18.2333 26.4962 16.5764H24.4962ZM24.4962 4V16.5764H26.4962V4H24.4962ZM23.4962 3C24.0485 3 24.4962 3.44772 24.4962 4H26.4962C26.4962 2.34314 25.1531 1 23.4962 1V3ZM8.55176 3H23.4962V1H8.55176V3ZM19.0087 19.5764L19.0087 19.5764V17.5764C18.3526 17.5764 17.7383 17.8982 17.3647 18.4374L19.0087 19.5764ZM14.3798 21.5118C15.1752 22.6598 16.8724 22.6598 17.6678 21.5118L16.0238 20.3728L16.0238 20.3728L14.3798 21.5118ZM13.039 19.5764L13.039 19.5764L14.683 18.4374C14.3094 17.8982 13.695 17.5764 13.039 17.5764V19.5764Z" fill="${fillColor}"/>`
    // + `</g>`
    // + `<defs>`
    // + `<filter id="filter0_d_1461_34296" x="0.551758" y="0" width="30.9446" height="31.3726" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">`
    // + `<feFlood flood-opacity="0" result="BackgroundImageFix"/>`
    // + `<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>`
    // + `<feOffset dy="4"/>`
    // + `<feGaussianBlur stdDeviation="2.5"/>`
    // + `<feComposite in2="hardAlpha" operator="out"/>`
    // + `<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>`
    // + `<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1461_34296"/>`
    // + `<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1461_34296" result="shape"/>`
    // + `</filter>`
    // + `</defs>`
    //   + '<text x="' + x + '" y="' + y + '" font-weight="bold" font-family="Calibri" font-size="12px" fill="black">' + index + '</text>'
    // + `</svg>`
    return {
      url: 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(markerImageSvg),
      size: new google.maps.Size(width, height),
      anchor: new google.maps.Point(width / 2, height),
      labelOrigin: new google.maps.Point(20, 20)
    }
  }


  buildVisitPlanStopIcon(isSelected, fillColor, isGroup, text) {
    let strokeColor = isGroup ? '#000000' : (isSelected ? '#FFEB3B' : '#F7F7F7');
    let strokeWidth = isGroup ? 2.3 : 1.5;
    let x = 6;
    let y = 13;
    let width = 30;
    let height = 30;

    let markerImageSvg =
      `<svg width="${width}" height="${height}" viewBox="0 0 21 22" xmlns="http://www.w3.org/2000/svg">`
      + `<path fill-rule="evenodd" clip-rule="evenodd" d="M3 1C1.89543 1 1 1.89543 1 3V15.5764C1 16.681 1.89543 17.5764 3 17.5764H7.48722C7.81525 17.5764 8.12241 17.7373 8.30922 18.0069L9.65007 19.9423C10.0478 20.5163 10.8964 20.5163 11.2941 19.9423L12.6349 18.0069C12.8217 17.7373 13.1289 17.5764 13.4569 17.5764H17.9445C19.049 17.5764 19.9445 16.681 19.9445 15.5764V3C19.9445 1.89543 19.049 1 17.9445 1H3Z" fill="white"/>`
      + `<path d="M12.6349 18.0069L11.8129 17.4374L12.6349 18.0069ZM9.65007 19.9423L10.4721 19.3728L10.4721 19.3728L9.65007 19.9423ZM11.2941 19.9423L12.1161 20.5118L11.2941 19.9423ZM8.30922 18.0069L7.48722 18.5764L8.30922 18.0069ZM2 3C2 2.44772 2.44771 2 3 2V0C1.34315 0 0 1.34314 0 3H2ZM2 15.5764V3H0V15.5764H2ZM3 16.5764C2.44772 16.5764 2 16.1287 2 15.5764H0C0 17.2333 1.34315 18.5764 3 18.5764V16.5764ZM7.48722 16.5764H3V18.5764H7.48722V16.5764ZM10.4721 19.3728L9.13121 17.4374L7.48722 18.5764L8.82807 20.5118L10.4721 19.3728ZM11.8129 17.4374L10.4721 19.3728L12.1161 20.5118L13.4569 18.5764L11.8129 17.4374ZM17.9445 16.5764H13.4569V18.5764H17.9445V16.5764ZM18.9445 15.5764C18.9445 16.1287 18.4968 16.5764 17.9445 16.5764V18.5764C19.6013 18.5764 20.9445 17.2333 20.9445 15.5764H18.9445ZM18.9445 3V15.5764H20.9445V3H18.9445ZM17.9445 2C18.4968 2 18.9445 2.44772 18.9445 3H20.9445C20.9445 1.34314 19.6013 0 17.9445 0V2ZM3 2H17.9445V0H3V2ZM13.4569 18.5764L13.4569 18.5764V16.5764C12.8009 16.5764 12.1865 16.8982 11.8129 17.4374L13.4569 18.5764ZM8.82807 20.5118C9.62344 21.6598 11.3207 21.6598 12.1161 20.5118L10.4721 19.3728L10.4721 19.3728L8.82807 20.5118ZM7.48722 18.5764L7.48722 18.5764L9.13121 17.4374C8.7576 16.8982 8.14327 16.5764 7.48722 16.5764V18.5764Z" fill="#FF88C1"/>`
      + `<path fill-rule="evenodd" clip-rule="evenodd" d="M3 1C1.89543 1 1 1.89543 1 3V15.5764C1 16.681 1.89543 17.5764 3 17.5764H7.48722C7.81525 17.5764 8.12241 17.7373 8.30922 18.0069L9.65007 19.9423C10.0478 20.5163 10.8964 20.5163 11.2941 19.9423L12.6349 18.0069C12.8217 17.7373 13.1289 17.5764 13.4569 17.5764H17.9445C19.049 17.5764 19.9445 16.681 19.9445 15.5764V3C19.9445 1.89543 19.049 1 17.9445 1H3Z" fill="${isSelected ? fillColor : (fillColor + 20)}"/>`
      + `<path d="M12.6349 18.0069L11.8129 17.4374L12.6349 18.0069ZM9.65007 19.9423L10.4721 19.3728L10.4721 19.3728L9.65007 19.9423ZM11.2941 19.9423L12.1161 20.5118L11.2941 19.9423ZM8.30922 18.0069L7.48722 18.5764L8.30922 18.0069ZM2 3C2 2.44772 2.44771 2 3 2V0C1.34315 0 0 1.34314 0 3H2ZM2 15.5764V3H0V15.5764H2ZM3 16.5764C2.44772 16.5764 2 16.1287 2 15.5764H0C0 17.2333 1.34315 18.5764 3 18.5764V16.5764ZM7.48722 16.5764H3V18.5764H7.48722V16.5764ZM10.4721 19.3728L9.13121 17.4374L7.48722 18.5764L8.82807 20.5118L10.4721 19.3728ZM11.8129 17.4374L10.4721 19.3728L12.1161 20.5118L13.4569 18.5764L11.8129 17.4374ZM17.9445 16.5764H13.4569V18.5764H17.9445V16.5764ZM18.9445 15.5764C18.9445 16.1287 18.4968 16.5764 17.9445 16.5764V18.5764C19.6013 18.5764 20.9445 17.2333 20.9445 15.5764H18.9445ZM18.9445 3V15.5764H20.9445V3H18.9445ZM17.9445 2C18.4968 2 18.9445 2.44772 18.9445 3H20.9445C20.9445 1.34314 19.6013 0 17.9445 0V2ZM3 2H17.9445V0H3V2ZM13.4569 18.5764L13.4569 18.5764V16.5764C12.8009 16.5764 12.1865 16.8982 11.8129 17.4374L13.4569 18.5764ZM8.82807 20.5118C9.62344 21.6598 11.3207 21.6598 12.1161 20.5118L10.4721 19.3728L10.4721 19.3728L8.82807 20.5118ZM7.48722 18.5764L7.48722 18.5764L9.13121 17.4374C8.7576 16.8982 8.14327 16.5764 7.48722 16.5764V18.5764Z" fill="${fillColor}"/>`
      + `<text x="${x}" y="${y}" font-weight="bold" font-family="Calibri" font-size="10px" fill="${isSelected ? 'white' : fillColor}">${text}</text>`
      + `</svg>`;
    return {
      url: 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(markerImageSvg),
      size: new google.maps.Size(width, height),
      anchor: new google.maps.Point(width / 2, height),
      labelOrigin: new google.maps.Point(20, 20)
    }
  }

  buildRoutedTaskIcon(isSelected, isHighlighted, fillColor, isBundle, index) {
    let strokeColor = isBundle ? '#000000' : '#F7F7F7';
    let strokeWidth = isBundle ? 2.3 : 1.5;
    let x = index >= 10 ? 11 : 14;
    let y = index >= 10 ? 22 : 22;
    let markerImageSvg = '<svg width="35" height="45" viewBox="0 0 35 45" fill="none" xmlns="http://www.w3.org/2000/svg">\n'
      + '<g filter="url(#filter0_d)">\n'
      + '<path d="M17 4C9.82713 4 4.00013 10.2094 4.00013 17.8258C3.95424 28.9751 16.5106 38.2279 17 38.595C17 38.595 30.0458 28.9751 29.9999 17.841C29.9999 10.2094 24.1729 4 17 4Z" fill="' + (isSelected ? '#FAFF00' : fillColor) + '"/>\n'
      + '<path d="M17 4C9.82713 4 4.00013 10.2094 4.00013 17.8258C3.95424 28.9751 16.5106 38.2279 17 38.595C17 38.595 30.0458 28.9751 29.9999 17.841C29.9999 10.2094 24.1729 4 17 4Z" stroke="' + strokeColor + '" stroke-width="' + strokeWidth + '"/>\n'
      + '</g>\n'
      + '<g filter="url(#filter1_d)">\n'
      + '<path d="M16.9985 26.7264C22.3705 26.7264 26.7254 22.3715 26.7254 16.9994C26.7254 11.6274 22.3705 7.27246 16.9985 7.27246C11.6264 7.27246 7.27148 11.6274 7.27148 16.9994C7.27148 22.3715 11.6264 26.7264 16.9985 26.7264Z" fill="#F7F7F7"/>\n'
      + '</g>\n'
      + '<defs>\n'
      + '<filter id="filter0_d" x="1.25" y="2.25" width="33.5" height="42.2796" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">\n'
      + '<feFlood flood-opacity="0" result="BackgroundImageFix"/>\n'
      + '<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/>\n'
      + '<feOffset dx="1" dy="2"/>\n'
      + '<feGaussianBlur stdDeviation="1.5"/>\n'
      + '<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"/>\n'
      + '<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow"/>\n'
      + '<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape"/>\n'
      + '</filter>\n'
      + '<filter id="filter1_d" x="5.27148" y="6.27246" width="25.4539" height="25.4539" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">\n'
      + '<feFlood flood-opacity="0" result="BackgroundImageFix"/>\n'
      + '<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/>\n'
      + '<feOffset dx="1" dy="2"/>\n'
      + '<feGaussianBlur stdDeviation="1.5"/>\n'
      + '<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"/>\n'
      + '<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow"/>\n'
      + '<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape"/>\n'
      + '</filter>\n'
      + '</defs>\n'
      + '<text x="' + x + '" y="' + y + '" font-weight="bold" font-family="Calibri" font-size="12px" fill="black">' + index + '</text>'
      + '</svg>';
    return {
      url: 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(markerImageSvg),
      size: new google.maps.Size(38, 47),
      anchor: new google.maps.Point(20, 41),
      labelOrigin: new google.maps.Point(20, 20)
    }
  }

  getRoutedActivityMarkerZIndex(marker, isHighlighted, index) {
    return isHighlighted ? this.mapZIndexes.routedTask.highlighted
      : this.mapZIndexes.routedTask.default + index;
  }

  buildPlanningRouteTaskIcon(strokeColor, isCompleted, isSelected) {
    return {
      path: 'M1,0 L26,0 C26.5522847,-1.01453063e-16 27,0.44771525 27,1 L27,19.7638889 C27,20.3161736 26.5522847,20.7638889 26,20.7638889 L16.9324255,20.7638889 L13.5,26.0318702 L10.1326862,20.7638889 L1,20.7638889 C0.44771525,20.7638889 3.62034905e-15,20.3161736 3.55271368e-15,19.7638889 L0,1 C-3.12899073e-16,0.44771525 0.44771525,-1.20591542e-16 1,-2.22044605e-16 Z',
      fillColor: isCompleted ? strokeColor : '#ffffff',
      fillOpacity: 1,
      scale: 1.1,
      strokeColor: isSelected ? '#FFEB3B' : strokeColor || 'white',
      strokeWeight: strokeColor ? 2.2 : 1.5,
      labelOrigin: new google.maps.Point(13, 10),
      anchor: new google.maps.Point(13, 27)
    };
  }

  buildStartEndPointIcon(isHighlighted) {
    return this.buildDepotTaskIcon(isHighlighted);
    // return {
    //   url: 'assets/images/icons/depot.png',
    //   fillOpacity: 1,
    //   scaledSize: new google.maps.Size(39, 49),
    //   strokeColor: isHighlighted ? '#000000' : '#FFFFFF',
    //   strokeWeight: 1.9,
    //   labelOrigin: new google.maps.Point(30, 8),
    //   anchor: new google.maps.Point(20, 45)
    // };
  }

  buildDepotTaskIcon(isSelected?, displayColor?) {
    // var icon = 'assets/images/icons/depots/depot.svg';

    if (!displayColor) {
      displayColor = '#7E7E7E';
    }

    let markerImageSvg = `<svg width="56" height="56" viewBox="0 0 56 56" fill="${displayColor}" xmlns="http://www.w3.org/2000/svg">\n` +
      '<g filter="url(#filter0_d_1858_3145)">\n' +
      '<path d="M8 25C8 13.9543 16.9543 5 28 5C39.0457 5 48 13.9543 48 25C48 36.0457 39.0457 45 28 45C16.9543 45 8 36.0457 8 25Z" fill="${displayColor}"/>\n' +
      '<path d="M29.9806 23.0184H33.5363C33.7001 23.0184 33.8325 23.151 33.8325 23.3148V26.8703C33.8325 27.0342 33.7001 27.1666 33.5363 27.1666H29.9806C29.8168 27.1666 29.6844 27.0342 29.6844 26.8703V23.3148C29.6844 23.151 29.8168 23.0184 29.9806 23.0184Z" fill="white"/>\n' +
      '<path d="M29.9806 28.2038H33.5363C33.7001 28.2038 33.8325 28.3362 33.8325 28.5V32.0556C33.8325 32.2194 33.7001 32.3518 33.5363 32.3518H29.9806C29.8168 32.3518 29.6844 32.2194 29.6844 32.0556V28.5C29.6844 28.3362 29.8168 28.2038 29.9806 28.2038Z" fill="white"/>\n' +
      '<path d="M28.3519 28.2038H24.7963C24.6324 28.2038 24.5 28.3362 24.5 28.5V32.0556C24.5 32.2194 24.6324 32.3518 24.7963 32.3518H28.3519C28.5158 32.3518 28.6482 32.2194 28.6482 32.0556V28.5C28.6482 28.3362 28.5158 28.2038 28.3519 28.2038Z" fill="white"/>\n' +
      '<path fill-rule="evenodd" clip-rule="evenodd" d="M29.6724 13.4372C28.8638 12.6764 27.6029 12.6764 26.7942 13.4372L18.3943 21.3408C17.9725 21.7377 17.7333 22.2911 17.7333 22.8702V34.2184C17.7333 35.3782 18.6735 36.3184 19.8333 36.3184H36.6333C37.7931 36.3184 38.7333 35.3782 38.7333 34.2184V22.8702C38.7333 22.2911 38.4942 21.7377 38.0724 21.3408L29.6724 13.4372ZM20.0667 22.9711L28.2333 15.287L36.4 22.9711V33.9851H20.0667V22.9711Z" fill="white"/>\n' +
      '</g>\n' +
      '<defs>\n' +
      '<filter id="filter0_d_1858_3145" x="0" y="0" width="56" height="56" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">\n' +
      '<feFlood flood-opacity="0" result="BackgroundImageFix"/>\n' +
      '<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>\n' +
      '<feOffset dy="3"/>\n' +
      '<feGaussianBlur stdDeviation="4"/>\n' +
      '<feComposite in2="hardAlpha" operator="out"/>\n' +
      '<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>\n' +
      '<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1858_3145"/>\n' +
      '<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1858_3145" result="shape"/>\n' +
      '</filter>\n' +
      '</defs>\n' +
      `</svg>\n`;

    return {
      url: 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(markerImageSvg),
      scaledSize: new google.maps.Size(42, 42),
      anchor: new google.maps.Point(21, 21),
    }

    // return {
    //   url: 'assets/images/icons/map/depot.svg',
    //   fillOpacity: 1,
    //   fillColor: displayColor,
    //   scaledSize: new google.maps.Size(42, 42),
    //   anchor: new google.maps.Point(21, 21)
    // };
  }

  convertActualTrackingToGeoJson(entries) {
    if (!entries || !entries.length) {
      return {
        type: "FeatureCollection",
        metadata: { generated: this.moment().valueOf(), title: "Actual Tracking" },
        features: []
      };
    }
    const features = _.reduce(entries, (acc, entry) => {
      // Must have location
      if (!entry.location || !entry.location.initial || !entry.location.initial.value || (entry.location.initial.value.lat === undefined)) {
        return acc;
      }
      const loc = entry.location.initial.value;
      acc.push({
        type: "Feature",
        id: entry.id,
        properties: {
          id: entry.id,
          type: entry.type,
          ref: entry,
          coordinates: { lat: loc.lat, lng: loc.lng }
        },
        geometry: {
          type: "Point",
          coordinates: [loc.lng, loc.lat]
        }
      });
      return acc;
    }, []);

    return {
      type: "FeatureCollection",
      metadata: { generated: this.moment().valueOf(), title: "Actual Tracking" },
      features: features
    };
  }

  /**
   * Raw GPS pings of the agent routes: a point per ping, numbered in time order across all routes,
   * and a line per route that connects its pings as they were recorded.
   */
  convertRawPingsToGeoJson(routes) {
    const routesPings = _.map(routes, (route) => _.sortBy(_.filter(route.locationUpdates, (ping) => {
      return _.isNumber(ping.latitude) && _.isNumber(ping.longitude);
    }), 'timestamp'));
    const pings = _.sortBy(_.flatten(routesPings), 'timestamp');

    const lineFeatures = _.reduce(routesPings, (acc, routePings) => {
      if (routePings.length > 1) {
        acc.push({
          type: "Feature",
          properties: {type: 'RAW_PINGS_LINE'},
          geometry: {
            type: "LineString",
            coordinates: _.map(routePings, (ping) => [ping.longitude, ping.latitude])
          }
        });
      }
      return acc;
    }, []);

    const pointFeatures = _.map(pings, (ping, index) => ({
      type: "Feature",
      properties: {
        type: 'RAW_PING',
        ref: {
          number: index + 1,
          total: pings.length,
          timestamp: ping.timestamp,
          latitude: ping.latitude,
          longitude: ping.longitude
        }
      },
      geometry: {
        type: "Point",
        coordinates: [ping.longitude, ping.latitude]
      }
    }));

    return {
      type: "FeatureCollection",
      metadata: {generated: this.moment().valueOf(), title: "Raw Pings"},
      features: [...lineFeatures, ...pointFeatures]
    };
  }

  getRawPingFeatureStyle(feature) {
    const color = '#7B5CE5';

    if (feature.getProperty('type') === 'RAW_PINGS_LINE') {
      return {
        clickable: false,
        strokeColor: color,
        strokeOpacity: 0.6,
        strokeWeight: 2,
        zIndex: this.mapZIndexes.routedTask.default - 2
      };
    }

    return {
      zIndex: this.mapZIndexes.routedTask.default - 1,
      icon: {
        path: google.maps.SymbolPath.CIRCLE,
        scale: 4,
        fillColor: color,
        fillOpacity: 1,
        strokeColor: '#FFFFFF',
        strokeWeight: 1
      }
    };
  }

  getActualTrackingFeatureStyle(feature) {
    const type = feature.getProperty('type');
    const text = type === 'Unknown' ? 'UK' : 'S';
    return {
      visible: true,
      zIndex: this.mapZIndexes.routedTask.default,
      icon: this.buildActualTrackingIcon(text)
    };
  }

  buildActualTrackingIcon(text) {
    let fillColor = '#808080'; // gray
    let strokeColor = '#F7F7F7';
    let strokeWidth = 1.5;
    let x = text === 'UK' ? 9 : 14;
    let y = 22;
    let width = 35;
    let height = 45;

    let markerImageSvg = `<svg width="${width}" height="${height}" viewBox="0 0 35 45" fill="none" xmlns="http://www.w3.org/2000/svg">\n`
      + '<g filter="url(#filter0_d)">\n'
      + '<path d="M17 4C9.82713 4 4.00013 10.2094 4.00013 17.8258C3.95424 28.9751 16.5106 38.2279 17 38.595C17 38.595 30.0458 28.9751 29.9999 17.841C29.9999 10.2094 24.1729 4 17 4Z" fill="' + fillColor + '"/>\n'
      + '<path d="M17 4C9.82713 4 4.00013 10.2094 4.00013 17.8258C3.95424 28.9751 16.5106 38.2279 17 38.595C17 38.595 30.0458 28.9751 29.9999 17.841C29.9999 10.2094 24.1729 4 17 4Z" stroke="' + strokeColor + '" stroke-width="' + strokeWidth + '"/>\n'
      + '</g>\n'
      + '<g filter="url(#filter1_d)">\n'
      + '<path d="M16.9985 26.7264C22.3705 26.7264 26.7254 22.3715 26.7254 16.9994C26.7254 11.6274 22.3705 7.27246 16.9985 7.27246C11.6264 7.27246 7.27148 11.6274 7.27148 16.9994C7.27148 22.3715 11.6264 26.7264 16.9985 26.7264Z" fill="#F7F7F7"/>\n'
      + '</g>\n'
      + '<defs>\n'
      + '<filter id="filter0_d" x="1.25" y="2.25" width="33.5" height="42.2796" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">\n'
      + '<feFlood flood-opacity="0" result="BackgroundImageFix"/>\n'
      + '<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/>\n'
      + '<feOffset dx="1" dy="2"/>\n'
      + '<feGaussianBlur stdDeviation="1.5"/>\n'
      + '<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"/>\n'
      + '<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow"/>\n'
      + '<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape"/>\n'
      + '</filter>\n'
      + '<filter id="filter1_d" x="5.27148" y="6.27246" width="25.4539" height="25.4539" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">\n'
      + '<feFlood flood-opacity="0" result="BackgroundImageFix"/>\n'
      + '<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/>\n'
      + '<feOffset dx="1" dy="2"/>\n'
      + '<feGaussianBlur stdDeviation="1.5"/>\n'
      + '<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"/>\n'
      + '<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow"/>\n'
      + '<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape"/>\n'
      + '</filter>\n'
      + '</defs>\n'
      + '<text x="' + x + '" y="' + y + '"  font-size="12px" fill="black">' + text + '</text>'
      + '</svg>';
    return {
      url: 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(markerImageSvg),
      size: new google.maps.Size(width, height),
      anchor: new google.maps.Point(width / 2, height),
      labelOrigin: new google.maps.Point(20, 20)
    }
  }

  getAccountIcon() {
    return {
      url: 'assets/images/icons/map/account.svg',
      fillOpacity: 1,
      scaledSize: new google.maps.Size(42, 42),
      anchor: new google.maps.Point(21, 21)
    };
  }

  getLabelClassByTask(task?, isRouted?, isUnpacked?) {
    const purpose = task.taskSpec.purpose;
    return this.getMarkerLabelClass(purpose, isRouted, isUnpacked);
  }

  originalAddressOptions() {
    return {
      visible: true,
      draggable: false,
      icon: {
        path: 'M12.1515,35.7 C11.655,35.0445 0,19.5375 0,12.6645 C0,5.682 5.7195,0 12.75,0 C19.7805,0 25.5,5.682 25.5,12.6645 C25.5,19.632 13.842,35.0505 13.347,35.7045 C13.206,35.8905 12.984,36 12.75,36 C12.5145,36 12.2925,35.889 12.1515,35.7 Z',
        fillColor: '#c5c5c5',
        fillOpacity: 1,
        scale: 1,
        strokeColor: 'white',
        strokeWeight: 1.5,
        anchor: new google.maps.Point(13, 32)
      }
    };
  }

  validatedAddressOptions() {
    return {
      visible: true,
      draggable: true,
      icon: {
        path: 'M12.1515,35.7 C11.655,35.0445 0,19.5375 0,12.6645 C0,5.682 5.7195,0 12.75,0 C19.7805,0 25.5,5.682 25.5,12.6645 C25.5,19.632 13.842,35.0505 13.347,35.7045 C13.206,35.8905 12.984,36 12.75,36 C12.5145,36 12.2925,35.889 12.1515,35.7 Z',
        fillColor: '#81C784',
        fillOpacity: 1,
        scale: 1,
        strokeColor: 'white',
        strokeWeight: 1.5,
        anchor: new google.maps.Point(13, 32)
      }
    };
  }

  buildMarkersByAddress(address, type, draggable) {
    return {
      id: address.id || address.location.latitude
        + address.location.longitude,
      coords: {
        latitude: _.get(address, 'location.latitude'),
        longitude: _.get(address, 'location.longitude')
      },
      options: {draggable: draggable || false},
      events: {},
      icon: {
        path: 'M12.1515,35.7 C11.655,35.0445 0,19.5375 0,12.6645 C0,5.682 5.7195,0 12.75,0 C19.7805,0 25.5,5.682 25.5,12.6645 C25.5,19.632 13.842,35.0505 13.347,35.7045 C13.206,35.8905 12.984,36 12.75,36 C12.5145,36 12.2925,35.889 12.1515,35.7 Z',
        fillColor: this.addressColors[type] || 'black',
        fillOpacity: 1,
        scale: 1,
        strokeColor: 'white',
        strokeWeight: 1.5,
        anchor: new google.maps.Point(13, 32)
      }
    };
  }

  buildMarkersByAddresses(addresses, type, draggable) {
    return _.map(addresses, (address) => {
      return this.buildMarkersByAddress(address, type, draggable);
    });
  }

  getUnroutedTaskMarkers(tasks?, selectedServiceIds?, slaRange?) {
    return _.map(tasks, (t, i) => {
      let packageItems = _.get(t, 'packageList[0].items'),
        purpose = t.taskSpec.purpose,
        status = t.status,
        isBundle = _.isEqual(t.taskType, 'BundledStopover'),
        isSelected = !_.isEqual(_.indexOf(selectedServiceIds, t.serviceId),
          -1),
        isUnpacked = packageItems ? this.deliveriesService.isDeliveryUnpacked(
          packageItems) : false,
        iconColor = slaRange ? this.getTaskColorByDateRange(slaRange.from, slaRange.to, t.taskSpec.notAfter) : undefined;

      return {
        id: t.id,
        serviceId: t.serviceId,
        depotId: _.get(t.taskSpec, 'depotReference.id'),
        status: t.status,
        taskId: t.id,
        unpacked: isUnpacked,
        taskType: t.taskType,
        bundleInfo: isBundle ? t.numberOfTasks : undefined,
        coords: t.taskSpec.address.location,
        // icon: isSelected ? mapsCommon.buildSelectedTaskIconByStatus(task.status) : mapsCommon.buildTaskIconByStatus(task.status),
        icon: this.getTaskMarkerIcon(purpose, status, isSelected, iconColor),
        zIndex: isSelected ? this.mapZIndexes.task.selected : this.mapZIndexes.task.default + i,
        // options: {
        //   optimized: false,
        //   zIndex: isSelected ? mapZIndexes.task.selected
        //       : mapZIndexes.task.default,
        //   visible: isVisible,
        //   // labelContent: isDepot ? 1 : (isUnpacked ? ''
        //   //     : t.taskSpec.purpose.charAt(0)),
        //   // labelClass: isDepot ? 'depot-label' : _getMarkerLabelClass(purpose,
        //   //     isUnpacked),
        //   // labelStyle: {
        //   //   zIndex: i + 1
        //   // },
        //   // labelAnchor: isDepot ? '-3 54' : (isUnpacked ? '7 25' : '5 25')
        // },
        taskSpec: t.taskSpec,
        show: false,
        selected: isSelected
      };

    });
  }

  getRouteTaskMarkersOld(tasks, isVisible) {
    return _.map(tasks, (t, i) => {
      const isBundle = _.isEqual(t.taskType, 'BundledStopover'),
        taskIndex = i + 1;

      return {
        id: t.id,
        serviceId: t.serviceId,
        taskId: t.id,
        taskType: t.taskType,
        bundleInfo: isBundle ? t.numberOfTasks : undefined,
        coords: t.taskSpec.address.location,
        icon: this.buildTaskIconPlaceholderWithStatus(t.taskSpec.purpose, t.status),
        zIndex: this.mapZIndexes.routedTask.default + taskIndex,
        // options: {
        //   zIndex: mapZIndexes.routedTask.default + taskIndex,
        //   visible: isVisible,
        //   label: {
        //     text: taskIndex.toString(),
        //     color: markerConfig[t.taskSpec.purpose].color,
        //     fontSize: '12px',
        //     fontWeight: 'bold'
        //   },
        // },
        taskSpec: t.taskSpec,
        show: false
      };
    });
  }

  buildUnRoutedActivityIcon(purpose, isSelected) {
    return isSelected ? this.buildTaskIconWithoutStatusSelected(purpose) : this.buildTaskIconWithoutStatus(purpose);
  }

  buildUnroutedTaskIcon(purpose, isSelected) {
    return {
      path: 'M0.43472032,14.721805 C0.548226157,15.118003 0.683347367,15.5079723 0.834856044,15.8816889 L1.19819537,16.6762259 L11.9999497,36 L22.8174883,16.6477105 L23.1595139,15.8954113 C23.3063979,15.5402832 23.4477524,15.131628 23.5651791,14.721805 C23.8534176,13.7140355 24,12.6689916 24,11.6162593 C24,5.21091304 18.6169681,0 11.9999497,0 C5.38303193,0 0,5.21091304 0,11.6162593 C0,12.6689916 0.146481847,13.7140355 0.43472032,14.721805 Z',
      fillColor: this.markerConfig[purpose].color,
      fillOpacity: 1,
      scale: 1,
      strokeColor: isSelected ? '#e1e100' : '#FFFFFF',
      // strokeColor: isSelected ? '#808080' : '#FFFFFF',
      strokeWeight: isSelected ? 4 : 1.5,
      labelOrigin: new google.maps.Point(30, 8),
      anchor: new google.maps.Point(13, 30)
    };
  }

  buildTaskIconWithStatusSelected(purpose, status) {
    return {
      url: 'assets/images/icons/tasks/' + purpose.toLowerCase() + '_' + status.toLowerCase() + '_selected.svg',
      size: new google.maps.Size(38, 47),
      anchor: new google.maps.Point(20, 41),
      labelOrigin: new google.maps.Point(20, 20)
    };
  }

  buildTaskIconWithStatus(purpose, status) {
    return {
      url: 'assets/images/icons/tasks/' + purpose.toLowerCase() + '_' + status.toLowerCase() + '.svg',
      size: new google.maps.Size(38, 47),
      anchor: new google.maps.Point(20, 41),
      labelOrigin: new google.maps.Point(20, 20)
    };
  }

  buildTaskIconWithoutStatusSelected(purpose) {
    return {
      url: 'assets/images/icons/tasks/' + purpose.toLowerCase() + '_contactnotavailable_selected.svg',
      size: new google.maps.Size(38, 47),
      anchor: new google.maps.Point(20, 41),
      labelOrigin: new google.maps.Point(20, 20)
    };
  }

  buildTaskIconWithoutStatus(purpose) {
    return {
      url: 'assets/images/icons/tasks/' + purpose.toLowerCase() + '.svg',
      size: new google.maps.Size(38, 47),
      anchor: new google.maps.Point(20, 41),
      labelOrigin: new google.maps.Point(20, 20)
    };
  }

  buildTaskIconPlaceholderWithStatus(purpose, status) {
    return {
      url: 'assets/images/icons/tasks/' + purpose.toLowerCase() + '_' + status.toLowerCase() + '_placeholder.svg',
      size: new google.maps.Size(38, 47),
      anchor: new google.maps.Point(20, 41),
      labelOrigin: new google.maps.Point(20, 20)
    };
  }

  buildTaskIconByColor(color, index, purpose) {
    return {
      url: 'assets/images/icons/tasks/' + purpose.toLowerCase() + '.svg',
      size: new google.maps.Size(38, 47),
      anchor: new google.maps.Point(20, 41),
      labelOrigin: new google.maps.Point(20, 20)
    };
  }

  buildTaskIcon(purpose?, isSelected?, strokeColor?) {
    switch (purpose) {
      case 'Pickup':
        return this.buildPickupIcon(isSelected, strokeColor);
      case 'Dropoff':
        return this.buildDropoffIcon(isSelected, strokeColor);
      case 'Operation':
        return this.buildOperationIcon(isSelected, strokeColor);
      default:
        return {}
    }
  }

  //Itinerary task map icon
  buildPickupIcon(isSelected?, strokeColor?) {
    return {
      path: 'M1,0 L26,0 C26.5522847,-1.01453063e-16 27,0.44771525 27,1 L27,19.7638889 C27,20.3161736 26.5522847,20.7638889 26,20.7638889 L16.9324255,20.7638889 L13.5,26.0318702 L10.1326862,20.7638889 L1,20.7638889 C0.44771525,20.7638889 3.62034905e-15,20.3161736 3.55271368e-15,19.7638889 L0,1 C-3.12899073e-16,0.44771525 0.44771525,-1.20591542e-16 1,-2.22044605e-16 Z',
      fillColor: '#EF6C00',
      fillOpacity: 1,
      scale: 1,
      strokeColor: isSelected ? '#FFEB3B' : strokeColor || 'white',
      strokeWeight: strokeColor ? 2.2 : 1.9,
      labelOrigin: new google.maps.Point(13, 10),
      anchor: new google.maps.Point(13, 27)
    }
  }

  // Itinerary task map icon
  buildDropoffIcon(isSelected?, strokeColor?) {
    return {
      path: 'M1,0 L26,0 C26.5522847,-1.01453063e-16 27,0.44771525 27,1 L27,19.7638889 C27,20.3161736 26.5522847,20.7638889 26,20.7638889 L16.9324255,20.7638889 L13.5,26.0318702 L10.1326862,20.7638889 L1,20.7638889 C0.44771525,20.7638889 3.62034905e-15,20.3161736 3.55271368e-15,19.7638889 L0,1 C-3.12899073e-16,0.44771525 0.44771525,-1.20591542e-16 1,-2.22044605e-16 Z',
      fillColor: '#1e88e5',
      fillOpacity: 1,
      scale: 1,
      strokeColor: isSelected ? '#FFEB3B' : '#FFFFFF',
      strokeWeight: strokeColor ? 2.2 : 1.9,
      labelOrigin: new google.maps.Point(13, 10),
      anchor: new google.maps.Point(13, 27)
    }
  }

  buildOperationIcon(isSelected, strokeColor) {
    return {
      path: 'M1,0 L26,0 C26.5522847,-1.01453063e-16 27,0.44771525 27,1 L27,19.7638889 C27,20.3161736 26.5522847,20.7638889 26,20.7638889 L16.9324255,20.7638889 L13.5,26.0318702 L10.1326862,20.7638889 L1,20.7638889 C0.44771525,20.7638889 3.62034905e-15,20.3161736 3.55271368e-15,19.7638889 L0,1 C-3.12899073e-16,0.44771525 0.44771525,-1.20591542e-16 1,-2.22044605e-16 Z',
      fillColor: '#31B69E',
      fillOpacity: 1,
      scale: 1,
      strokeColor: isSelected ? '#FFEB3B' : '#FFFFFF',
      strokeWeight: strokeColor ? 2.2 : 1.9,
      labelOrigin: new google.maps.Point(13, 10),
      anchor: new google.maps.Point(13, 27)
    }
  }

  getClusterIcons() {
    return [
      {
        height: 74,
        url: "//ccplugins.co/markerclusterer/images/m6.png",
        width: 74,
        anchorText: [-10, -10]
      },
      {
        height: 74,
        url: "//ccplugins.co/markerclusterer/images/m6.png",
        width: 74,
        anchorText: [-10, -10]
      },
      {
        height: 74,
        url: "//ccplugins.co/markerclusterer/images/m6.png",
        width: 74,
        anchorText: [-10, -10]
      },
      {
        height: 74,
        url: "//ccplugins.co/markerclusterer/images/m6.png",
        width: 74,
        anchorText: [-10, -10]
      },
      {
        height: 74,
        url: "//ccplugins.co/markerclusterer/images/m6.png",
        width: 74,
        anchorText: [-10, -10]
      }]
  }

  getDepotClusterIcons() {
    return [
      {
        height: 74,
        textColor: 'white',
        url: "assets/images/icons/depot.png",
        width: 74,
        anchorIcon: [55, 23],
        anchorText: [-30, -1]
      },
      {
        height: 74,
        textColor: 'white',
        url: "assets/images/icons/depot.png",
        width: 74,
        anchorIcon: [55, 23],
        anchorText: [-30, -1]
      },
      {
        height: 74,
        textColor: 'white',
        url: "assets/images/icons/depot.png",
        width: 74,
        anchorIcon: [55, 23],
        anchorText: [-30, -1]
      },
      {
        height: 74,
        textColor: 'white',
        url: "assets/images/icons/depot.png",
        width: 74,
        anchorIcon: [55, 23],
        anchorText: [-30, -1]
      },
      {
        height: 74,
        textColor: 'white',
        url: "assets/images/icons/depot.png",
        width: 74,
        anchorIcon: [55, 23],
        anchorText: [-30, -1]
      }]
  }

  deliveriesToMarkers(deliveries, selectedDeliveryId) {
    return _.chain(deliveries)
      .flatMap((d) => {
        return d.taskList
      })
      .filter((t) => {
        return !!t.taskSpec.address.location;
      })
      .map((filteredTask) => {
        return this.deliveryTaskToMarker(filteredTask, selectedDeliveryId);
      })
      .value();
  }

  stepsToMarkers(steps) {
    const stepsPickupTasks = _.chain(steps)
      .flatMap((s) => {
        if (!!s.pickup) {
          return s.pickup
        }
      })
      .filter((s) => {
        return !!s?.location?.address?.location;
      })
      .map((s, index) => {
        return this.stepTaskToMarker(s, index);
      })
      .value();

    const stepsDestinationTasks = _.chain(steps)
      .flatMap((s) => {
        if (!!s.destination) {
          return s.destination
        }
      })
      .filter((s) => {
        return !!s?.location?.address?.location;
      })
      .map((s, index) => {
        return this.stepTaskToMarker(s, index);
      })
      .value();

    return _.concat(stepsPickupTasks, stepsDestinationTasks);
  }

  attemptsToMarkers(attempts) {

    const attemptsPickupTasks = _.chain(attempts)
      .flatMap((a) => {
        return a.pickup
      })
      .filter((a) => {
        return !!a.address.location;
      })
      .map((a, index) => {
        return this.attemptTaskToMarker(a, 'Pickup');
      })
      .value();

    const attemptsDestinationTasks = _.chain(attempts)
      .flatMap((a) => {
        return a.destination
      })
      .filter((a) => {
        return !!a.address.location;
      })
      .map((a, index) => {
        return this.attemptTaskToMarker(a, 'Dropoff');
      })
      .value();

    return _.concat(attemptsPickupTasks, attemptsDestinationTasks);
  }

  shipmentsToMarkers(shipments, selectedShipmentId) {
    return _.chain(shipments)
      .flatMap((s) => {
        return s.tasks || [];
      })
      .filter((t) => {
        return !!_.get(t, 'address.location');
      })
      .map((filteredTask, index) => {
        return this.shipmentTaskToMarker(filteredTask, selectedShipmentId, index);
      })
      .value();
  }

  buildPolygons(serviceAreas?, isVisible?, routeId?) {
    return _.map(serviceAreas, (area, index) => {
      return {
        id: area.areaId,
        routeId: routeId,
        path: _.map(area.coordinates, (coordinate) => {
          return {
            latitude: coordinate.latitude,
            longitude: coordinate.longitude
          }
        }),
        color: area.color,
        stroke: {
          color: '#6060FB',
          weight: 1
        },
        editable: false,
        draggable: false,
        geodesic: false,
        visible: isVisible,
        fill: {
          color: area.color,
          opacity: 0.4,
          name: area.areaName
        }
      }
    })
  }

  buildClusteringAreaPolygons(clusteringAreas?, isVisible?) {
    return _.chain(clusteringAreas)
      .filter((area) => !!area?.coordinates?.length)
      .map((area) => {
        const areaName = area.name || area.serviceAreaName || _.get(area, 'areaReference.name');
        const color = area.color || '#6060FB';

        return {
          id: area.id,
          path: _.map(area.coordinates, (coordinate) => {
            return {
              latitude: coordinate.latitude ?? coordinate.lat,
              longitude: coordinate.longitude ?? coordinate.lng
            };
          }),
          color: color,
          stroke: {
            color: '#6060FB',
            weight: 1
          },
          editable: false,
          draggable: false,
          geodesic: false,
          visible: isVisible,
          fill: {
            color: color,
            opacity: 0.4,
            name: areaName
          }
        };
      })
      .value();
  }

  buildFeaturePolygons(features?, isVisible?: boolean, isEditable?: boolean, selectedId?: string, isClickable?: boolean) {
    return _.compact(_.map(features, (feature) => {
      if (!this.isValidFeaturePolygon(feature)) {
        return undefined;
      }
      const polygonId = this.getFeaturePolygonId(feature);
      const isSelected = !_.isUndefined(selectedId) && selectedId === polygonId;
      const fillColor = feature.properties.fill || '#7E7E7E';
      return {
        id: polygonId,
        routeId: feature.properties.routeId,
        path: feature.geometry,
        color: fillColor,
        zIndex: isSelected ? 99 : 1,
        stroke: {
          color: this.darkenHexColor(fillColor, (isSelected ? 0.5 : 0.2)),
          weight: isSelected ? 4 : 1,
          zIndex: isSelected ? 99 : 1
        },
        clickable: _.isUndefined(isClickable) ? true : isClickable,
        editable: isEditable || false,
        draggable: isEditable || false,
        geodesic: false,
        visible: isVisible,
        fit: false,
        fill: {
          color: fillColor,
          opacity: 0.4,
          name: feature.properties.areaName || feature.properties.name
        }
      }
    }));
  }

  buildFeaturePolygon(feature?, isVisible?, isEditable?, isClickable?, isStatic?) {
    const fillColor = feature.properties.fill || '#676767';
    const path = this.hasFeaturePolygonCoordinates(feature) ? feature.geometry : this.buildFeaturePolygonPath(feature);
    return {
      id: this.getFeaturePolygonId(feature),
      routeId: feature.properties.routeId,
      path: path,
      color: fillColor,
      stroke: {
        color: this.darkenHexColor(fillColor, 0.2),
        weight: 1
      },
      clickable: isClickable || false,
      editable: isEditable || false,
      draggable: isClickable || isEditable || false,
      geodesic: false,
      visible: isVisible,
      static: isStatic || false,
      fill: {
        color: feature.properties.fill,
        opacity: 0.4
      }
    }
  }

  getFeaturePolygonId(feature?) {
    const id = feature.properties.areaId || feature.properties.id || feature.properties.locationId;
    if (!_.isUndefined(id) && !_.isNull(id)) {
      return String(id);
    }
    if (!feature.properties._polygonId) {
      feature.properties._polygonId = String(this.UUIDService.generate());
    }
    return feature.properties._polygonId;
  }

  hasFeaturePolygonCoordinates(feature?) {
    return this.isValidPolygonRing(this.getFeaturePolygonRing(feature));
  }

  isValidFeaturePolygon(feature?) {
    return this.hasFeaturePolygonCoordinates(feature);
  }

  getFeaturePolygonRing(feature?) {
    const coordinates = _.get(feature, 'geometry.coordinates');
    if (!_.isArray(coordinates) || !coordinates.length) {
      return [];
    }
    const first = coordinates[0];
    if (!_.isArray(first)) {
      return [];
    }
    if (_.isNumber(first[0])) {
      return coordinates;
    }
    if (_.isArray(first[0])) {
      return first;
    }
    return [];
  }

  isValidPolygonRing(ring?) {
    return _.isArray(ring) && ring.length >= 3;
  }

  buildFeaturePolygonPath(feature?) {
    const ring = this.getFeaturePolygonRing(feature);
    if (!this.isValidPolygonRing(ring)) {
      return {
        type: 'Polygon',
        coordinates: []
      };
    }
    return {
      type: 'Polygon',
      coordinates: [angular.copy(ring)]
    };
  }

  removeCustomPolygons(polygons) {
    _.forEach(polygons, (p) => {
      p.setMap(null);
    });
  }

  deliveryTaskToMarker(task, selectedDeliveryId) {
    const isSelected = task.id === selectedDeliveryId;
    return {
      id: task.id,
      parentId: task.serviceId,
      icon: this.buildTaskIcon(task.taskSpec.purpose, isSelected),
      location: task.taskSpec.address.location
    };
  }

  stepTaskToMarker(task, index) {
    return {
      id: task.id || `${task.purpose}${index}`,
      icon: this.buildStepTaskIcon(task.purpose, index),
      location: task.location.address.location
    };
  }

  attemptTaskToMarker(task, taskPurpose) {
    const id = this.UUIDService.generate();
    return {
      id: id,
      icon: this.buildTaskIconWithoutStatus(taskPurpose),
      location: task.address.location
    };
  }

  shipmentTaskToMarker(task, selectedShipmentId, taskIndex) {
    const isSelected = task.shipmentId === selectedShipmentId;
    return {
      id: taskIndex,
      // shipmentId: shipmentId,
      // icon: task.purpose === 'Pickup' ? buildPickupIcon(false) : buildDropoffIcon(false),
      icon: taskIndex === 0 ? this.buildPickupIcon(false) : this.buildDropoffIcon(false),
      location: task.address.location
    };
  }


  getTaskMarkerIcon(purpose?, status?, isSelected?, iconColor?) {

    let purposeText = (!_.isUndefined(purpose)) ? this.getIconPurposeText(purpose, iconColor) : '';
    let fillColor = iconColor || this.markerConfig[purpose].color;
    let statusIndicator = (!_.isUndefined(status)) ? this.getIconStatusIndication(status) : undefined;

    let svg = '<svg width="38" height="47" viewBox="0 0 38 47" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
      '<g filter="url(#filter0_d)">\n' +
      '<path d="M20 6C12.8271 6 7.00013 12.2094 7.00013 19.8258C6.95424 30.9751 19.5106 40.2279 20 40.595C20 40.595 33.0458 30.9751 32.9999 19.841C32.9999 12.2094 27.1729 6 20 6Z" fill="' + fillColor + '"/>\n' +
      '<path d="M20 6C12.8271 6 7.00013 12.2094 7.00013 19.8258C6.95424 30.9751 19.5106 40.2279 20 40.595C20 40.595 33.0458 30.9751 32.9999 19.841C32.9999 12.2094 27.1729 6 20 6Z" stroke="' + (isSelected ? '#FAFF00' : (iconColor || 'white')) + '" stroke-width="' + (isSelected ? 2.2 : 1.5) + '"/>\n' +
      '</g>\n' +
      '<g filter="url(#filter1_d)">\n' +
      '<path d="M19.9985 28.7264C25.3705 28.7264 29.7254 24.3715 29.7254 18.9994C29.7254 13.6274 25.3705 9.27246 19.9985 9.27246C14.6264 9.27246 10.2715 13.6274 10.2715 18.9994C10.2715 24.3715 14.6264 28.7264 19.9985 28.7264Z" fill="#F7F7F7"/>\n' +
      '</g>\n' +
      statusIndicator +
      purposeText +
      '<defs>\n' +
      '<filter id="filter0_d" x="4.25" y="4.25" width="33.5" height="42.2796" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">\n' +
      '<feFlood flood-opacity="0" result="BackgroundImageFix"/>\n' +
      '<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/>\n' +
      '<feOffset dx="1" dy="2"/>\n' +
      '<feGaussianBlur stdDeviation="1.5"/>\n' +
      '<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"/>\n' +
      '<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow"/>\n' +
      '<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape"/>\n' +
      '</filter>\n' +
      '<filter id="filter1_d" x="8.27148" y="8.27246" width="25.4539" height="25.4539" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">\n' +
      '<feFlood flood-opacity="0" result="BackgroundImageFix"/>\n' +
      '<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/>\n' +
      '<feOffset dx="1" dy="2"/>\n' +
      '<feGaussianBlur stdDeviation="1.5"/>\n' +
      '<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"/>\n' +
      '<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow"/>\n' +
      '<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape"/>\n' +
      '</filter>\n' +
      '<filter id="filter2_d" x="0.25" y="0.25" width="19.5" height="19.5" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">\n' +
      '<feFlood flood-opacity="0" result="BackgroundImageFix"/>\n' +
      '<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/>\n' +
      '<feOffset dy="1"/>\n' +
      '<feGaussianBlur stdDeviation="1.5"/>\n' +
      '<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"/>\n' +
      '<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow"/>\n' +
      '<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape"/>\n' +
      '</filter>\n' +
      '</defs>\n' +
      '</svg>';

    return {
      url: 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(svg),
      // url: 'data:image/png;base64,' + encodeURIComponent(url),
      size: new google.maps.Size(38, 47),
      anchor: new google.maps.Point(20, 41),
      labelOrigin: new google.maps.Point(20, 20)
    };

  }

  private getIconStatusIndication(status) {
    const fillColor = this.markerColorByStatus[status];
    return status ? '<g filter="url(#filter2_d)" fill="' + fillColor + '">\n' +
      '<circle cx="10" cy="9" r="6" fill="#79090A"/>\n' +
      '<circle cx="10" cy="9" r="6" stroke="#F7F7F7" stroke-width="1.5"/>\n' +
      '</g>\n' : '';
  }

  private getIconPurposeText(purpose, textColor) {
    const fillColor = textColor || this.markerConfig[purpose].color;
    const text = this.$filter('translate')(purpose.charAt(0));
    return purpose ? '<text x="15" y="24" fill="' + fillColor + '" font-size="14px" font-weight="700" font-family="Arial">' + text + '</text>' : '';
  }

  // function getTaskMarkerIconNew(purpose, status, isSelected, iconColor) {
  //     return {
  //         url: 'assets/images/icons/task.png',
  //         fillOpacity: 1,
  //         scaledSize: new google.maps.Size(42, 42),
  //         anchor: new google.maps.Point(21, 21)
  //     };
  // }


  getTaskMarkerIconNew(purpose?, status?, isSelected?, slaColorIndex?, timeWindowColorIndex?) {
    const iconWidth = 34;
    const iconHeight = 47;

    const originHeight = slaColorIndex ?
      (iconHeight * this.markersSpriteConfig.slaColor[purpose][slaColorIndex]) :
      (timeWindowColorIndex ? (iconHeight * this.markersSpriteConfig.timeWindowColor[purpose][timeWindowColorIndex]) : (iconHeight * this.markersSpriteConfig.purpose[purpose]));
    const originWidth = status ? (iconWidth * this.markersSpriteConfig.status[status]) : 0;

    return {
      url: _.isUndefined(timeWindowColorIndex) ? (!!isSelected ? 'assets/images/icons/map/selected_markers.png' : 'assets/images/icons/map/markers.png') :
        (!!isSelected ? 'assets/images/icons/map/markers-time-window-selected.png' : 'assets/images/icons/map/markers-time-window.png'),
      fillOpacity: 1,
      // This marker height and width.
      size: new google.maps.Size(iconWidth, iconHeight - 6),
      // The image origin in the sprite png.
      origin: new google.maps.Point(originWidth, originHeight),
      // The anchor for this image is the base of the flagpole at (0, 32).
      anchor: new google.maps.Point(iconWidth / 2, iconHeight - 6)
    };
  }


  // function getTaskMarkerIconNew(purpose, status, isSelected, iconColor) {
  //     var iconWidth = 27;
  //     var iconHeight = 15;
  //     return {
  //         url: 'assets/images/battery/battery_sprite.png',
  //         fillOpacity: 1,
  //         // This marker height and width.
  //         size: new google.maps.Size(iconWidth, iconHeight),
  //         // The image origin in the sprite png.
  //         origin: new google.maps.Point(iconWidth, 0),
  //         // The anchor for this image is the base of the flagpole at (0, 32).
  //         anchor: new google.maps.Point(iconWidth/2, iconHeight/2),
  //     };
  // }

  getTaskColorByDateRange(notBefore, notAfter, taskNotAfter) {
    let from = this.moment(notBefore),
      to = this.moment(notAfter),
      diffInMs = Math.abs(this.moment(from).diff(to)),
      quarterGap = diffInMs / 4;

    let taskDiffInMs = taskNotAfter - notBefore;
    let colorIndex = 0;

    while (taskDiffInMs > 0) {
      taskDiffInMs -= quarterGap;
      colorIndex++
    }

    return this.markerColorBySla[colorIndex];
  }

  getTaskColorIndexByDateRange(notBefore, notAfter, taskNotAfter) {
    let from = this.moment(notBefore),
      to = this.moment(notAfter),
      diffInMs = Math.abs(this.moment(from).diff(to)),
      quarterGap = diffInMs / 4;

    let taskDiffInMs = taskNotAfter - notBefore;
    let colorIndex = 0;

    while (taskDiffInMs > 0) {
      taskDiffInMs -= quarterGap;
      colorIndex++
    }

    return colorIndex;
  }

  getTaskColorIndexByTimeWindow(notBefore) {
    return this.moment(notBefore).hour();
  }

  initPolyline() {
    return {
      path: [],
      visible: true,
      stroke: {
        color: '#2196F3',
        weight: 2,
        opacity: 1
      },
      icons: [{
        icon: {
          path: google.maps.SymbolPath.BACKWARD_OPEN_ARROW
        },
        offset: '50px',
        repeat: '150px'
      }]
    };
  }

  initActiveWindow(options?) {
    const defaultOptions = {pixelOffset: new google.maps.Size(0, -30), disableAutoPan: true};
    return {
      coords: {},
      options: _.merge(defaultOptions, options),
      show: false
    }
  }

  private decodePolylineCoordinates(encodedPolyline) {

    return _.map(google.maps.geometry.encoding.decodePath(encodedPolyline), (d: any) => {
      return [d.lng(), d.lat()]
    })
  }

  private darkenHexColor(hex: string, amount: number): string {
    let r = parseInt(hex.slice(1, 3), 16);
    let g = parseInt(hex.slice(3, 5), 16);
    let b = parseInt(hex.slice(5, 7), 16);

    r = Math.max(0, Math.floor(r * (1 - amount)));
    g = Math.max(0, Math.floor(g * (1 - amount)));
    b = Math.max(0, Math.floor(b * (1 - amount)));

    const toHex = (n: number) => n.toString(16).padStart(2, '0');

    return `#${toHex(r)}${toHex(g)}${toHex(b)}`;
  }

  private lightenHexColor(hex: string, amount: number): string {
    let r = parseInt(hex.slice(1, 3), 16);
    let g = parseInt(hex.slice(3, 5), 16);
    let b = parseInt(hex.slice(5, 7), 16);

    // Calculate the distance to white (255) and add the proportional amount
    r = Math.min(255, Math.floor(r + (255 - r) * amount));
    g = Math.min(255, Math.floor(g + (255 - g) * amount));
    b = Math.min(255, Math.floor(b + (255 - b) * amount));

    const toHex = (n: number) => n.toString(16).padStart(2, '0');

    return `#${toHex(r)}${toHex(g)}${toHex(b)}`;
  }
}

angular
  .module('bringoz.admin.map')
  .service('mapsCommonService', MapsCommonService);

